import "../vendor.css";
import React, { useState, useEffect, useRef } from "react";
import Navbar from "../../../../components/navBarVendor";
import Page from "../../../../components/Page";
import CustomDataGrid from "../../../../components/table";
import { useHistory } from "react-router-dom";
import { getDetailPO, changeScreenPO } from "../../../../configs/redux/action/Vendor/purchaseOrder";


import { saveAs } from 'file-saver';
import * as excelJS from "exceljs";

import { Autocomplete, Skeleton, TextField, Box, Checkbox, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip, Input, } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  changeScreenIS,
  getListPO,
  getListPOAll,
  getItemListPO,
  getItemWhtType,
  createInvoice,
  jurnalInvoice,
  uploadItemListExcel,
  getItemType,
  getTaxConfiguration
} from "../../../../configs/redux/action/Vendor/invoiceSubmission";
import Button from "../../../../components/button";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import moment from "moment";
import NumberFormat from "react-number-format";
import { DataGrid } from '@mui/x-data-grid';
import ConvertFormat from "../../../../helper/curency"
import { buildTableFilterQuery, combineQueryStrings, normalizeTableFilterOperator } from "../../../../configs/utilities";

const PAGE_SIZE_OPTIONS = [5, 10, 25, 100];
const TABLE_FILTER_DEBOUNCE_MS = 350;
const DEFAULT_PO_PAGINATION = {
  page: 1,
  pageSize: 10,
  totalCount: 0,
};

const mapCreateInvoicePoTypeFilter = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized.includes("non")) return "0";
  if (normalized.includes("trade")) return "1";
  return String(value || "").trim();
};

const getPoRemainingAmount = (po) => {
  const rawValue = po?.remainingAmountBalance ?? po?.netValue ?? 0;
  const parsed = Number(rawValue);
  return Number.isFinite(parsed) ? parsed : 0;
};

const hasTableFilterInputValue = (filterModel) => {
  const items = Array.isArray(filterModel?.items) ? filterModel.items : [];

  return items.some((item) => {
    const value = Array.isArray(item.value) ? item.value[0] : item.value;
    return value !== null && value !== undefined && String(value).trim() !== "";
  });
};

const hasTableFilterDraft = (filterModel) => {
  const items = Array.isArray(filterModel?.items) ? filterModel.items : [];
  return items.length > 0;
};

const normalizeItemListFilterValue = (value) => {
  if (value === null || value === undefined || value === "NULL") {
    return "";
  }

  return String(value).trim().toLowerCase();
};

const getFilterItemField = (item) => item.columnField || item.field || "";

const getFilterItemValue = (item) => {
  const rawValue = Array.isArray(item.value) ? item.value[0] : item.value;
  return rawValue;
};

const isValueLessFilterOperator = (operator) => {
  const normalized = normalizeTableFilterOperator(operator);
  return normalized === "isempty" || normalized === "isnotempty";
};

const hasFilterItemValue = (item) => {
  if (isValueLessFilterOperator(item.operatorValue || item.operator)) {
    return true;
  }

  const rawValue = getFilterItemValue(item);
  return rawValue !== null && rawValue !== undefined && String(rawValue).trim() !== "";
};

const matchesItemListFilter = (rowValue, item) => {
  const operator = normalizeTableFilterOperator(item.operatorValue || item.operator);
  const value = normalizeItemListFilterValue(rowValue);

  if (operator === "isempty") {
    return value === "";
  }

  if (operator === "isnotempty") {
    return value !== "";
  }

  const rawValues = Array.isArray(item.value) ? item.value : [item.value];
  return rawValues.some((rawValue) => {
    const filterValue = normalizeItemListFilterValue(rawValue);
    if (!filterValue) {
      return true;
    }

    switch (operator) {
      case "equals":
        return value === filterValue;
      case "startswith":
        return value.startsWith(filterValue);
      case "endswith":
        return value.endsWith(filterValue);
      case "contains":
      default:
        return value.includes(filterValue);
    }
  });
};

const filterItemListRows = (rows, filterModel) => {
  const sourceRows = Array.isArray(rows) ? rows : [];
  const activeItems = (Array.isArray(filterModel?.items) ? filterModel.items : [])
    .filter((item) => getFilterItemField(item) && hasFilterItemValue(item));

  if (activeItems.length === 0) {
    return sourceRows;
  }

  const linkOperator = String(filterModel?.linkOperator || filterModel?.logicOperator || "and").toLowerCase();
  return sourceRows.filter((row) => {
    const matcher = (item) => matchesItemListFilter(row[getFilterItemField(item)], item);
    return linkOperator === "or" ? activeItems.some(matcher) : activeItems.every(matcher);
  });
};

const getNumberFormatConfig = (currencyCode) => {
  const code = Array.isArray(currencyCode) ? currencyCode[0] : currencyCode;
  return code === "IDR"
    ? { thousandSeparator: ".", decimalSeparator: ",", allowedDecimalSeparators: [","] }
    : { thousandSeparator: ",", decimalSeparator: ".", allowedDecimalSeparators: [".", ","] };
};

function parseFlexibleAmount(value) {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;

  const raw = value.toString().trim().replace(/\s/g, "");
  if (!raw) return 0;

  const hasComma = raw.includes(",");
  const hasDot = raw.includes(".");

  if (hasComma && hasDot) {
    const lastComma = raw.lastIndexOf(",");
    const lastDot = raw.lastIndexOf(".");
    const normalized = lastComma > lastDot
      ? raw.replace(/\./g, "").replace(/,/g, ".")
      : raw.replace(/,/g, "");
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  if (hasComma) {
    const parts = raw.split(",");
    const decimalPart = parts[parts.length - 1];
    const normalized = decimalPart.length <= 2
      ? raw.replace(/\./g, "").replace(/,/g, ".")
      : raw.replace(/,/g, "");
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  if (hasDot && /^-?\d{1,3}(\.\d{3})+$/.test(raw)) {
    const parsed = Number(raw.replace(/\./g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatLocalAmount(value) {
  if (value === null || value === undefined || value === "") return "";
  const amount = Number(value ?? 0);
  if (!Number.isFinite(amount)) return "";
  return new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 2,
  }).format(amount);
}

function normalizeCurrencyAmount(value, currencyCode) {
  const code = Array.isArray(currencyCode) ? currencyCode[0] : currencyCode;
  const amount = Number(value ?? 0);
  if (!Number.isFinite(amount)) return 0;
  return code === "IDR" ? Math.round(amount) : Number(amount.toFixed(2));
}

function isSameCurrencyAmount(left, right, currencyCode) {
  const code = Array.isArray(currencyCode) ? currencyCode[0] : currencyCode;
  const tolerance = code === "IDR" ? 0 : 0.01;
  return Math.abs(normalizeCurrencyAmount(left, code) - normalizeCurrencyAmount(right, code)) <= tolerance;
}

function NumberFormatCustom(props) {
  const {
    inputRef,
    onChange,
    name,
    thousandSeparator = ".",
    decimalSeparator = ",",
    allowedDecimalSeparators,
    ...other
  } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        if (onChange) {
          onChange({
            target: {
              name,
              value: values.value,
            },
          });
        }
      }}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      allowedDecimalSeparators={allowedDecimalSeparators}
      decimalScale={2}
      isNumericString
    />
  );
}

function RemoveFormatting(nilai, currencyCode = "IDR") {
  if (nilai === null || nilai === undefined || nilai === "") return 0;
  if (typeof nilai === "number") return Number.isFinite(nilai) ? nilai : 0;

  const code = Array.isArray(currencyCode) ? currencyCode[0] : currencyCode;
  const numberString = nilai.toString().trim().replace(/\s/g, "");

  if (code === "IDR" && /^-?\d{1,3}(\.\d{3})+$/.test(numberString)) {
    return Number(numberString.replace(/\./g, ""));
  }

  const directNumber = Number(numberString);
  if (Number.isFinite(directNumber) && !numberString.includes(",")) {
    return directNumber;
  }

  const normalized =
    code === "IDR"
      ? numberString.replace(/\./g, "").replace(/,/g, ".")
      : numberString.replace(/,/g, "");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}



function InvoiceSubmission() {
  const today = new Date();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loadingChangePage, setLoadingChangePage] = useState(false);
  const [checkAllListPO, setCheckAllListPO] = useState(false);
  const [checkedListPO, setCheckedListPO] = useState([]);
  const [checkAllItemList, setCheckAllItemList] = useState(false);
  const [checkedItemList, setCheckedItemList] = useState([]);
  const [checkAllItemType, setCheckAllItemType] = useState(false);
  const [indeterminateListPO, setIndetListPO] = useState(false);
  const [indeterminateItemType, setIndeterminateItemType] = useState(false);
  const [checkedItemType, setCheckedItemType] = useState([]);
  const { listPo, listPoPagination, dropdownWht, listSupportDoc, listItemType, listTaxConfig } = useSelector((state) => state.vendorInvoiceSubmission || {});
  const listPoRows = Array.isArray(listPo) ? listPo : [];
  const poPagination = listPoPagination || DEFAULT_PO_PAGINATION;
  //const { listSysparam,listBankAccount,listCompanyCode,dueDate} = useSelector((state) => state.status);
  const { listBankAccount, listCompanyCode, dueDate } = useSelector((state) => state.status);
  const { listInfoVendor } = useSelector((state) => state.infoVendor);
  const [loadingListPO, setLoadingListPO] = useState(false);
  const [loadingItemList, setLoadingItemList] = useState(false);
  const [loadingItemType, setLoadingItemType] = useState(false);
  const hiddenFileInput = useRef(null);

  const isExporter = listInfoVendor?.[0]?.isExporter === 1 || listInfoVendor?.[0]?.IsExporter === 1 || (listItemType && listItemType.some(x => x.description === "Other" || x.itemTypeDesc === "Other"));

  const [data, setData] = useState({
    VendorInvoiceNumber: "",
    poType: "",
    PaymentType: "",
    PaymentTerm: "",
    companyCode: "",
    vendorCode: listInfoVendor[0].vendorCode,
    TaxType: "",
    itemTypeTaxConfId: null,
    itemTypeVatAmount: 0,
    itemTypeDppAmount: 0,
    PONo: [],
    ItemList: [],
    ItemListtemp: [],
    selectedItemList: [],
    selectedItemType: [],
    TotalAmountBeforeTax: 0,
    TotalAmountServiceMaterial: 0,
    TotalAmountItemType: false,
    TotalAmountInstallment: false,
    TotalAmountToBePaid: 0,
    itemTypeAmount: 0,
    whtType: null,
    whtSubType: null,
    whtRate: null,
    TopType: null,
    TopInstallment: 0,
    TopInstallmentDetail: [],
    TopDueDate: null,
    TopPercentage: null,
    TopPercentageCondition: false,

    TopAmount: 0,
    BankName: "",
    BankAccountNo: null,
    BankAccountName: "",

    PaymentRequestNumber: "",
    invoiceDate: "",
    attachment: []
  });
  const [currency, setCurrency] = useState(null)
  const [selectPO, setSelectedPO] = useState([])
  const [selectListPo, setSelectedListPo] = useState([])
  // const [selectTempResPO,setTempRes]=useState([])
  // const [selectionModel, setSelectionModel] = useState(()=>data.ItemList.filter((r) => r.isCheckBox === false).map((r) => r.id));
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pagePO, setPagePO] = useState(0);
  const [pageSizePO, setPageSizePO] = useState(10);
  const [basePOQuery, setBasePOQuery] = useState("");
  const [activePOQuery, setActivePOQuery] = useState("");
  const [tableFilterQuery, setTableFilterQuery] = useState("");
  const [itemListFilterModel, setItemListFilterModel] = useState({ items: [] });
  const tableFilterDebounceRef = useRef(null);
  const [pageSizeItemList, setPageSizeItemList] = useState(10);
  // Cache of ALL rows for the current header filter → drives client-side column filtering across all pages
  const [allPoRowsCache, setAllPoRowsCache] = useState([]);
  const [poTableFilterModel, setPoTableFilterModel] = useState({ items: [] });
  const [inputItemTypeAmount, setInputItemTypeAmount] = useState({});

  // Determine if any column filter is actively typed
  const _isPoFilterActive = (poTableFilterModel?.items || []).some((item) => {
    const v = Array.isArray(item.value) ? item.value[0] : item.value;
    return v !== undefined && v !== null && String(v).trim() !== "";
  });
  // Switch to client-mode (all-rows cache) once cache is loaded and filter is active
  const _usePoClientMode = _isPoFilterActive && allPoRowsCache.length > 0;

  const [dropdownWhtType, setWhtType] = useState([{ value: "0", label: "---" }])
  const [dropdownWhtSubType, setWhtSubType] = useState([{ value: "0", label: "---" }])
  const [dropdownTaxConfig, setTaxConfig] = useState([{ value: "0", label: "---", vat: 0, dpp: 0, dppNumber: "", isPercentage: false }])
  const [dataItemType, setItemType] = useState(listItemType);
  const [dataItemList, setItemList] = useState(listTaxConfig);
  const [attachSupportDoc, setAttachSupportDoc] = useState(listSupportDoc);
  const [selectTemp, setSelectTemp] = useState([])
  const [dropdownBank, setBankCode] = useState([]);
  const [dropdownBankNo, setBankNo] = useState([]);
  const [dropdownCompanyCode, setCompanyCode] = useState([]);
  const [loadingSave, setLoadingSave] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [uploadItemList, setUploadItemList] = useState(false)
  const [fileUploadItemList, setFileUploadItemList] = useState([])
  const [errorDialog, setErrorDialog] = useState(false);
  const [listErrorMsg, setListErrorMsg] = useState([]);
  const [pageErr, setPageErr] = useState(5);
  const [loadingUpload, setLoadingUpload] = useState(false);

  const tableFilterQueryField = {
    poNo: { queryField: "PurchaseNo", includeOperator: true },
    costCenter: { queryField: "CostCenter", includeOperator: true },
    createBy: { queryField: "CreatedBy", includeOperator: true },
    paymentTerm: { queryField: "PaymentTermFilter", includeOperator: true },
    paymentIn: { type: "number", queryField: "PaymentIn" },
    companyCode: { queryField: "CompanyCodeFilter", includeOperator: true },
    poType: { queryField: "POTypeFilter", transform: mapCreateInvoicePoTypeFilter },
    purchaseOrganization: { queryField: "PurchaseOrganization", includeOperator: true },
    purchaseGroup: { queryField: "PurchaseGroup", includeOperator: true },
    exchangeRate: { type: "number", queryField: "ExchangeRate" },
    incoterms: { queryField: "IncotermCode", includeOperator: true },
    incotermsDesc: { queryField: "IncotermDescription", includeOperator: true },
    currency: { queryField: "Currency", includeOperator: true },
  };


  const exportToExcel = () => {
    const newData = data.ItemList
    const newDataTemp = []
    newData.forEach((d, idx) => {
      newDataTemp.push({
        poNo: d.poNo,
        item: d.item,
        awbInvoiceNo: d.awbInvoiceNo === null ? "NULL" : d.awbInvoiceNo,
        material: d.material,
        shortText: d.shortText,
        condition: d.condition,
        conditionDesc: d.conditionDesc,
        quantity: d.quantity,
        currency: d.currency,
        netValue: d.netValue,
        nonPOCharges: d.nonPOCharges,
        itemStatus: d.itemStatus === null ? "NULL" : d.itemStatus,
        grStatus: d.grStatus,
        billedQty: d.billedQty,
      })
    })

    if (newDataTemp.length > 0) {
      const date = moment().format('YYYY-MM-DD')
      const workbook = new excelJS.Workbook();
      workbook.creator = "SYSTEM";
      workbook.lastModifiedBy = "SYSTEM";
      workbook.created = new Date();
      workbook.modified = new Date();

      let sheet = workbook.addWorksheet("ItemList");
      sheet.getRow(1).values = [
        "PO Number",
        "Item",
        "AWB/INV NO",
        "Material",
        "Short Text (Item)",
        "CnTy",
        "Cnty Desc",
        "Qty",
        "Curr",
        "Net Value",
        "Non PO Charges",
        "itemStatus",
        "GR Status",
        "Billed Qty",
      ];
      sheet.columns = [
        {
          key: "poNo",
          width: 30
        },
        {
          key: "item",
          width: 20
        },
        {
          key: "awbInvoiceNo",
          width: 25
        },
        {
          key: "material",
          width: 25
        },
        {
          key: "shortText",
          width: 40
        },
        {
          key: "condition",
          width: 20
        },
        {
          key: "conditionDesc",
          width: 30
        },
        {
          key: "quantity",
          width: 30
        },
        {
          key: "currency",
          width: 30
        },
        {
          key: "netValue",
          width: 30
        },
        {
          key: "nonPOCharges",
          width: 30
        },
        {
          key: "itemStatus",
          width: 30
        },
        {
          key: "grStatus",
          width: 30
        },
        {
          key: "billedQty",
          width: 20
        },
      ];
      sheet.addRows(newDataTemp);

      const row = sheet.getRow(1);
      row.eachCell((cell, rowNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'ffff00' },

        };
        sheet.getColumn(rowNumber).alignment = {
          vertical: "top",
          horizontal: "left"
        };
        sheet.getColumn(rowNumber).font = { size: 14, family: 2 };
      });

      workbook.xlsx.writeBuffer().then(function (buffer) {
        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
        saveAs(blob, `ItemList-${date}.xlsx`);
      });
    } else {
      Toastify({
        text: "No data available.",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top",
        position: "right",
        stopOnFocus: true,
        style: {
          background: "#FFCC00",
        },
      }).showToast();
    }

  }

  const handleUploadItemList = (e) => {
    setLoadingUpload(true)
    e.preventDefault();
    const files = fileUploadItemList

    const formData = new FormData();
    formData.append("vendorCode", listInfoVendor[0].vendorCode)
    formData.append("file", files);
    dispatch(uploadItemListExcel(formData)).then((res) => {
      if (res.data.message === "Success") {

        const itemTemp = data.ItemList
        const dataTemp = res.data.invoiceUploadItemList

        const filterItemTemp = itemTemp.filter((elem) => dataTemp.find(({ poNo, item, conditionCode }) => elem.poNo === poNo && elem.item === Number(item) && elem.condition === conditionCode))

        let newValueItemList = [];

        for (let i = 0; i < filterItemTemp.length; i += 1) {
          let newArray = dataTemp.filter(function (el) {
            return el.poNo === filterItemTemp[i].poNo && Number(el.item) === filterItemTemp[i].item && el.conditionCode === filterItemTemp[i].condition;
          });
          if (newArray.length === 0) {
            newValueItemList.push(filterItemTemp[i]);
          }
          else {
            filterItemTemp[i].isCheckBox = true
            filterItemTemp[i].billedQty = Number(newArray[0].billedQty);
            filterItemTemp[i].balanceQty = Number(newArray[0].billedQty);
            filterItemTemp[i].amountInvoice = filterItemTemp[i].currency === "IDR" ? Math.ceil(Number(newArray[0].billedQty) * filterItemTemp[i].pricePerUnit) : (Number(newArray[0].billedQty) * filterItemTemp[i].pricePerUnit).toFixed(2)
            newValueItemList.push(filterItemTemp[i]);
          }
        };

        const findIsCheckboxFalse = itemTemp.filter((elem) => !newValueItemList.find(({ poNo, item, condition }) => elem.poNo === poNo && elem.item === item && elem.condition === condition))

        const mergedArray = [...newValueItemList, ...findIsCheckboxFalse]

        let newDataSelected = []
        let amountBeforeTax = []
        let curr = []
        let idSelectionModel = []
        newValueItemList.forEach((d) => {
          idSelectionModel.push(d.id)
          curr.push(d.currency)
          amountBeforeTax.push(Number(d.amountInvoice));
          newDataSelected.push({
            amountInvoice: Number(d.amountInvoice),
            item: d.item,
            billedQty: parseFloat(d.balanceQty),
            conditionId: d.conditionId,
            poNo: d.poNo,
          });
        })
        let newAmmountBeforeTax = amountBeforeTax.reduce(
          (a, b) => a + b,
          0
        )
        const uniqueCurr = [...new Set(curr)];

        setCheckedItemList(idSelectionModel)
        setSelectionModel(idSelectionModel)
        setCurrency(uniqueCurr)
        setSelectedRows(newValueItemList)
        setData({
          ...data,
          ItemList: mergedArray,
          TotalAmountBeforeTax: newAmmountBeforeTax,
          selectedItemList: newDataSelected,
        })
        setLoadingUpload(false)
        setUploadItemList(false)
        Toastify({
          text: "Upload Item Success",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          // stopOnFocus: true,
          style: {
            background: "#5EBA7D",
          },
        }).showToast();
      } else {
        setUploadItemList(false)
        setLoadingUpload(false)
        const error = res.data.listErrorUpload;
        error.forEach((data, ind) => {
          data.id = ind + 1;
        });
        setListErrorMsg(error);
        setErrorDialog(true);
      }

    })
      .catch((err) => {
        setUploadItemList(false)
        setLoadingUpload(false)
        const error = err.data.listErrorUpload;
        error.forEach((data, ind) => {
          data.id = ind + 1;
        });
        setListErrorMsg(error);
        setErrorDialog(true);
      })
  }

  const loadListPO = (nextQuery = activePOQuery, nextPage = pagePO, nextPageSize = pageSizePO) => {
    setActivePOQuery(nextQuery);
    setLoadingListPO(true);
    return dispatch(getListPO(nextQuery, {
      page: nextPage + 1,
      pageSize: nextPageSize,
    })).then((res) => {
      setLoadingListPO(false);
      return res;
    }).catch((err) => {
      setLoadingListPO(false);
      throw err;
    });
  };

  const handleChangeHeader = (event) => {
    const dataNew = { ...data };
    dataNew[event.target.name] = event.target.value;
    setData(dataNew);

    let query = "?";
    Object.keys(dataNew).forEach((filternya) => {
      if (
        dataNew[filternya] !== "" &&
        dataNew[filternya] !== "All" &&
        dataNew[filternya] !== "---" &&
        dataNew[filternya] !== null &&
        dataNew[filternya] !== undefined
      ) {
        switch (filternya) {
          case "poType":
            query += "POType=" + dataNew[filternya] + "&";
            break;
          case "companyCode":
            query += "CompanyCode=" + dataNew[filternya] + "&";
            break;
          case "vendorCode":
            query += "VendorCode=" + dataNew[filternya] + "&";
            break;
          case "paymentTerm":
            query += "PaymentTerm=" + dataNew[filternya] + "&";
            break;
          case "PaymentType":
            query += "PaymentType=" + dataNew[filternya] + "&";
            break;
          default:
            query += "";
        }
      }
    });

    query = query.substring(0, query.length - 1);
    if (dataNew.poType !== "" && dataNew.companyCode !== "" && dataNew.PaymentType !== "" && dataNew.TaxType !== "") {
      const nextQuery = combineQueryStrings(query, tableFilterQuery);
      setPagePO(0);
      setBasePOQuery(query);
      setActivePOQuery(nextQuery);
      loadListPO(nextQuery, 0, pageSizePO)
        .then((res) => {
          setCheckedListPO([]);
          setSelectedRows([]);
          dispatch(getItemType());
          setPoTableFilterModel({ items: [] });
          setAllPoRowsCache([]);
          dispatch(getListPOAll(query))
            .then((allRes) => {
              setAllPoRowsCache(Array.isArray(allRes.data) ? allRes.data : []);
            })
            .catch(() => { });
        })
        .catch(() => {
          dispatch({
            type: "LIST_PO",
            payload: [],
          });
        })
    } else {
      setCheckedListPO([]);
      setSelectedRows([]);
      setPagePO(0);
      setBasePOQuery("");
      setActivePOQuery("");
      setAllPoRowsCache([]);
      setPoTableFilterModel({ items: [] });
      dispatch({
        type: "LIST_PO",
        payload: [],
      });
    }
  };

  const handleTableFilterChange = (model) => {
    // Always sync local filter model → switches DataGrid to client-mode when cache is ready
    setPoTableFilterModel(model || { items: [] });

    const hasDraft = hasTableFilterDraft(model);
    const hasInput = hasTableFilterInputValue(model);

    if (tableFilterDebounceRef.current) {
      clearTimeout(tableFilterDebounceRef.current);
    }

    if (hasDraft && !hasInput) {
      return;
    }

    const nextTableFilterQuery = buildTableFilterQuery(model, tableFilterQueryField);
    if (nextTableFilterQuery === tableFilterQuery) {
      return;
    }

    tableFilterDebounceRef.current = setTimeout(() => {
      setTableFilterQuery(nextTableFilterQuery);
      // Only hit server when all-rows cache is NOT yet ready (fallback)
      if (!basePOQuery || allPoRowsCache.length > 0) {
        return;
      }
      const nextQuery = combineQueryStrings(basePOQuery, nextTableFilterQuery);
      setPagePO(0);
      setActivePOQuery(nextQuery);
      loadListPO(nextQuery, 0, pageSizePO);
    }, TABLE_FILTER_DEBOUNCE_MS);
  };

  const handleItemListFilterChange = (model) => {
    setItemListFilterModel(model || { items: [] });
  };

  const handleFormChange = (event, dataSelect) => {
    const dataNew = { ...data };
    dataNew[event.target.name] = event.target.value;

    if (event.target.name === "BankName") {
      const bankData = listBankAccount.filter((d) => d.bankCode === event.target.value);
      const defaultBank = bankData.length === 1 ? bankData[0] : null;
      setData({
        ...data,
        BankName: event.target.value,
        BankAccountNo: defaultBank?.bankAccount || "",
        BankAccountName: defaultBank?.bankAccountName || "",
      });
      return;
    }

    setData(dataNew);
    // if(event.target.name === "vat"){
    //   if(event.target.value === "1"){
    //     setWhtType(dropdownWhtType.filter((d)=>d.value === "1"))
    //   }else{
    //     setWhtType(dropdownWhtType.filter((d)=>d.value === "0"))
    //   }
    // }
    if (event.target.name === "TopInstallment") {
      let dataTemp = [];
      let number = parseInt(dataNew.TopInstallment);
      let i;
      for (i = 1; i <= number; i++) {
        dataTemp.push({
          id: i,
          installment: i,
          dueDate: null,
          amount: null,
        });
      }
      setTopInstallmentDetail(dataTemp);
    } else if (event.target.name === "TopType") {
      if (event.target.value === "Installment") {
        setData({
          ...data,
          TopType: data.PaymentType !== "Advanced Payment" ? "Installment" : data.TopType,
          TopDueDate: dueDate,
          TopInstallment: 0,
          TopInstallmentDetail: [],
        })
      } else if (event.target.value === "Credit") {
        setData({
          ...data,
          TopType: "Credit",
          TopDueDate: dueDate,
          TopInstallment: 0,
          TopInstallmentDetail: [],
          TopPercentage: null,
          TopAmount: 0,
        })
        setTopInstallmentDetail([])
      } else if (event.target.value === "DownPayment" || event.target.value === "COD" || event.target.value === "CBD") {
        setData({
          ...data,
          TopType: event.target.value,
          TopDueDate: dueDate,
          TopInstallment: 0,
          TopInstallmentDetail: [],
        })
        setTopInstallmentDetail([])
      }
    }
    else if (event.target.name === "whtType") {
      const dataItemTemp = dataItemType
      const selected = dataItemTemp.findIndex((row) => row.id === dataSelect.id)
      dataItemTemp[selected].itemTypeWhtType = event.target.value
      setItemType(dataItemTemp)

      // let newDataWhtSubType = [{ label: "---", value: "---" }];
      let subTypeTemp = dropdownWht.filter((d, index) => {
        return d.companyCode === data.companyCode && d.taxType === dataItemTemp[selected].itemTypeWhtType
      });

      if (subTypeTemp.length >= 1) {
        // remark sementara
        // let newDataDrowdownSubType=[]
        subTypeTemp.forEach((data, i) => {
          data.label = data.serviceType
          // newDataDrowdownSubType.push({
          // name:data.serviceType,
          // value:data.serviceType
        })
        // });
        // setWhtSubType(newDataDrowdownSubType);
        setWhtSubType(subTypeTemp);
      }

    }
    else if (event.target.name === "VendorInvoiceNumber") {
      let dataTemp = attachSupportDoc
      dataTemp[0].documentNo = event.target.value
      setAttachSupportDoc(dataTemp)
    } else if (event.target.name === "BankAccountNo") {
      const dataBank = listBankAccount.filter((d) => {
        return d.bankCode === data.BankName && d.bankAccount === event.target.value
      })
      setData({
        ...data,
        BankAccountNo: event.target.value,
        BankAccountName: dataBank[0]?.bankAccountName || ""
      })
    } else if (event.target.name === "TopPercentage") {
      let amount = (event.target.value / 100) * Number(data.TotalAmountBeforeTax)
      if (amount > data.TotalAmountBeforeTax) {
        setData({
          ...data,
          TopPercentage: data.TopType === "DownPayment" ? event.target.value > 99 ? 99 : event.target.value : event.target.value > 100 ? 100 : event.target.value,
          TopAmount: amount.toFixed(2),
          TopPercentageCondition: true
        })
      } else {
        setData({
          ...data,
          TopPercentage: data.TopType === "DownPayment" ? event.target.value > 99 ? 99 : event.target.value : event.target.value > 100 ? 100 : event.target.value,
          TopAmount: amount.toFixed(2),
          TopPercentageCondition: false
        })
      }
    }
  };

  const handleChangeBilledQty = (e, dataSelect) => {
    const inputValue = e.target.value;

    // Simpan tampilan input (boleh "1,2" atau "0,3", bahkan kosong)
    setBilledQtyInput((prev) => ({
      ...prev,
      [dataSelect.id]: inputValue,
    }));

    // Parsing
    const raw = inputValue.replace(",", ".");
    let parsed = parseFloat(raw);

    // Jika bukan angka valid, biarkan user mengetik dulu
    if (isNaN(parsed) || parsed < 0) return;

    const datatemp = data.ItemListtemp;
    const selectedRow = datatemp.find((row) => row.id === dataSelect.id);
    const balanceQtytemp = selectedRow?.balanceQty ?? 0;

    // Jika melebihi balanceQty, pakai balanceQty
    if (parsed > balanceQtytemp) {
      parsed = balanceQtytemp;

      // Update input tampilan ke balanceQty juga
      setBilledQtyInput((prev) => ({
        ...prev,
        [dataSelect.id]: parsed.toString().replace(".", ","),
      }));
    }

    // Update data
    const dataNew = data.ItemList.map((obj) => {
      if (obj.id === dataSelect.id) {
        const pricePerUnit =
          obj.quantity && obj.netValue
            ? obj.netValue / obj.quantity
            : obj.pricePerUnit ?? 0;

        const amount = parsed * pricePerUnit;
        const amountInvoice =
          obj.currency === "IDR"
            ? Math.round(amount)
            : parseFloat(amount.toFixed(2));

        return {
          ...obj,
          billedQty: parsed,
          balanceQty: parsed,
          amountInvoice,
          pricePerUnit,
        };
      }
      return obj;
    });

    const selectedItemList = data.selectedItemList.length > 0
      ? dataNew
        .filter((d) => d.isCheckBox)
        .map((d) => ({
          amountInvoice: Number(d.amountInvoice),
          item: d.item,
          billedQty: Number(d.balanceQty),
          conditionId: d.conditionId,
          poNo: d.poNo,
          id: d.id,
        }))
      : [];

    let beforeTax = 0;
    if (selectedItemList.length > 0) {
      const amounts = selectedItemList.map((d) => Number(d.amountInvoice));
      beforeTax = currency?.[0] === "IDR"
        ? Math.round(amounts.reduce((a, b) => a + b, 0))
        : amounts.reduce((a, b) => a + b, 0).toFixed(2);
    }

    setData({
      ...data,
      ItemList: dataNew,
      selectedItemList,
      TotalAmountBeforeTax: selectedItemList.length > 0 ? beforeTax : 0,
    });
  };


  const handleChangeItemType = (e, dataSelect, vatRate = 0, dppRate = 0) => {
    const name = e.target.name;
    const rawVal = e.target.value;

    // ==== HELPERS: konsisten angka utk semua currency ====
    const isIDR = currency?.[0] === "IDR";
    const toNum = (v) => {
      const cleaned = RemoveFormatting ? RemoveFormatting(v, currency?.[0]) : v;
      const n = Number(cleaned);
      return Number.isFinite(n) ? n : 0;
    };
    const roundAmt = (n) => (isIDR ? Math.ceil(Number(n || 0)) : Number(Number(n || 0).toFixed(2)));

    // ambil value mentah sesuai field
    let valueItemType = name === "itemTypeAmount" ? toNum(rawVal) : rawVal;

    let ammountTemp = [];
    let ammountToBePaid = [];

    // NOTE: tetap mengikuti pola kamu (mutasi array yang sama)
    const dataNew = dataItemType;
    const selected = dataNew.findIndex((row) => row.id === dataSelect.id);
    if (selected < 0) return;

    // JANGAN paksa Number utk TaxConfId (bisa NaN)
    if (name === "itemTypeTaxConfId") {
      dataNew[selected][name] = valueItemType; // string/id
    } else {
      dataNew[selected][name] = Number(valueItemType);
    }

    const { vat, wht } = dataSelect;

    // >>> FIX TYPO: yang benar cek 'name', bukan 'e.target.value'
    if (name === "itemTypeDppAmount") {
      dataNew[selected].itemTypeDppAmount = toNum(rawVal);
    }

    // ==== VAT calculation (dibulatkan sesuai currency) ====
    if (vat === 1) {
      if (dataNew[selected].itemTypeVat !== null && dataNew[selected].itemTypeVat !== 0) {
        // base: pakai Amount jika DPP 0
        const base =
          (dataNew[selected].itemTypeDppAmount || 0) > 0
            ? dataNew[selected].itemTypeDppAmount
            : (dataNew[selected].itemTypeAmount || 0);

        dataNew[selected].itemTypeVatAmount = roundAmt(
          (Number(dataNew[selected].itemTypeVatRate || 0) / 100) * base
        );
      } else {
        dataNew[selected].itemTypeWhtAmountToBePaid =
          (dataNew[selected].description === "Other" && !isExporter) ? 0 : (dataNew[selected].itemTypeAmount || 0);
      }
    } else {
      dataNew[selected].itemTypeWhtAmountToBePaid =
        (dataNew[selected].description === "Other" && !isExporter) ? 0 : (dataNew[selected].itemTypeAmount || 0);
    }

    // ==== WHT & VAT = 1 ====
    if (wht === 1 && vat === 1) {
      const whtRate = Number(dataNew[selected].itemTypeWhtRate || 0) / 100;
      dataNew[selected].itemTypeWhtAmount = roundAmt(
        whtRate * Number(dataNew[selected].itemTypeAmount || 0)
      );

      if (dataNew[selected].description === "Other" && !isExporter) {
        dataNew[selected].itemTypeWhtAmountToBePaid = 0;
      } else {
        const baseAmount =
          (dataNew[selected].itemTypeAmount || 0) +
          Number(dataNew[selected].itemTypeVatAmount || 0) -
          Number(dataNew[selected].itemTypeWhtAmount || 0);

        dataNew[selected].itemTypeWhtAmountToBePaid = roundAmt(baseAmount);
      }
    }
    // ==== WHT = 0 & VAT = 1 ====
    else if (wht === 0 && vat === 1) {
      if (
        dataNew[selected].itemTypeVatAmount !== null &&
        parseInt(dataNew[selected].itemTypeVatAmount) !== 0
      ) {
        if (dataNew[selected].description === "Other" && !isExporter) {
          dataNew[selected].itemTypeWhtAmountToBePaid = 0;
        } else {
          dataNew[selected].itemTypeWhtAmountToBePaid = roundAmt(
            Number(dataNew[selected].itemTypeVatAmount || 0) +
            (dataNew[selected].itemTypeAmount || 0)
          );
        }
      }
    }

    // ==== jika ubah WHT Rate ====
    if (name === "itemTypeWhtRate") {
      dataNew[selected][name] = Number(valueItemType);

      const whtRate = Number(valueItemType || 0) / 100;
      const amount = dataNew[selected].itemTypeAmount || 0;

      dataNew[selected].itemTypeWhtAmount = roundAmt(whtRate * amount);

      if (dataNew[selected].description === "Other" && !isExporter) {
        dataNew[selected].itemTypeWhtAmountToBePaid = 0;
      } else {
        const result =
          (dataNew[selected].itemTypeAmount || 0) +
          Number(dataNew[selected].itemTypeVatAmount || 0) -
          Number(dataNew[selected].itemTypeWhtAmount || 0);

        dataNew[selected].itemTypeWhtAmountToBePaid = roundAmt(result);
      }
    }
    // ==== jika ubah TaxConfId (pakai vatRate argumen) ====
    else if (name === "itemTypeTaxConfId") {
      dataNew[selected].itemTypeVatAmount = roundAmt(
        (Number(vatRate || 0) / 100) * (dataNew[selected].itemTypeDppAmount || 0)
      );

      if (dataNew[selected].description === "Other" && !isExporter) {
        dataNew[selected].itemTypeWhtAmountToBePaid = 0;
      } else {
        const result =
          (dataNew[selected].itemTypeAmount || 0) +
          Number(dataNew[selected].itemTypeVatAmount || 0) -
          Number(dataNew[selected].itemTypeWhtAmount || 0);

        dataNew[selected].itemTypeWhtAmountToBePaid = roundAmt(result);
      }
    }

    // ======= amount to be paid & agregat (tetap pola kamu) =======
    let filterSelected = dataNew.filter(function (o1) {
      return checkedItemType.includes(o1.id) && Number(o1.itemTypeAmount || 0) !== 0;
    });

    const filterMaterialService = filterSelected.filter(
      (d) => d.description === "Services" || d.description === "Material" || d.description === "Other"
    );

    let updateCheckBoxtrue = checkedItemType.filter(function (o1) {
      return filterSelected.some(function (o2) {
        return o1 === o2.id;
      });
    });
    setCheckedItemType(updateCheckBoxtrue);

    filterMaterialService.forEach((d) => ammountTemp.push(Number(d.itemTypeAmount || 0)));
    filterSelected.forEach((d) => {
      if (d.description !== "Other" || isExporter) {
        ammountToBePaid.push(Number(d.itemTypeWhtAmountToBePaid || 0));
      }
    });

    // total sebagai NUMBER yang sudah dibulatkan sesuai currency
    const amountNum = roundAmt(ammountTemp.reduce((a, b) => a + b, 0));
    const ammountToBePaidTemp = roundAmt(
      ammountToBePaid.slice(0, ammountToBePaid.length).reduce((a, b) => a + b, 0)
    );

    let selectedTemp = [];
    filterSelected.forEach((d) => {
      selectedTemp.push({
        itemTypeNo: d.seq,
        itemTypeDesc: d.description,
        itemTypeAmount: Number(d.itemTypeAmount || 0),
        itemTypeVat: d.itemTypeVat === null ? 0 : d.itemTypeVat,
        itemTypeVatRate: d.itemTypeVatRate,
        itemTypeTaxConfId: d.itemTypeTaxConfId === undefined ? "" : d.itemTypeTaxConfId,
        itemTypeVatAmount: Number(d.itemTypeVatAmount || 0),
        itemTypeDppRate: d.itemTypeDppRate === undefined ? 0 : d.itemTypeDppRate,
        itemTypeDppAmount: Number(d.itemTypeDppAmount || 0),
        itemTypeWht: d.itemTypeWht,
        itemTypeWhtType: d.itemTypeWhtType,
        itemTypeWhtSubtype: d.itemTypeWhtSubtype,
        itemTypeWhtRate: Number(d.itemTypeWhtRate || 0),
        itemTypeWhtAmount: Number(d.itemTypeWhtAmount || 0),
        itemTypeWhtAmountToBePaid: Number(d.itemTypeWhtAmountToBePaid || 0),
      });
    });

    const hasOtherWithAmount = filterSelected.some(
      (item) => (item.itemTypeDesc === "Other" || item.description === "Other") && Number(item.itemTypeAmount || 0) !== 0
    );
    if (data.PaymentType === "Credit Payment") {
      const amountBeforeTaxNum = roundAmt(Number(data.TotalAmountBeforeTax ?? 0));

      setData({
        ...data,
        // simpan angka; format tampilan biar UI yang atur
        TotalAmountServiceMaterial: amountNum,
        TotalAmountItemType: (hasOtherWithAmount && isExporter) ? false : amountNum !== amountBeforeTaxNum,
        TotalAmountToBePaid: ammountToBePaidTemp,
        selectedItemType: selectedTemp,
      });
    } else if (data.PaymentType === "Advanced Payment") {
      const topAmountNum = roundAmt(Number(data.TopAmount ?? 0));

      setData({
        ...data,
        TotalAmountServiceMaterial: amountNum,
        TotalAmountItemType: (hasOtherWithAmount && isExporter) ? false : amountNum !== topAmountNum,
        TotalAmountToBePaid: ammountToBePaidTemp,
        selectedItemType: selectedTemp,
      });
    }

    setItemType(dataNew);
  };





  const handleCheckBox = (e, dataSelect) => {
    const dataItemTemp = dataItemType.map((row) =>
      row.id === dataSelect.id ? { ...row } : row
    );
    const selected = dataItemTemp.findIndex((row) => row.id === dataSelect.id)
    if (selected < 0) return;

    const isIDR = currency?.[0] === "IDR";
    const roundAmt = (value) =>
      isIDR ? Math.ceil(Number(value || 0)) : Number(Number(value || 0).toFixed(2));
    const toNum = (value) => {
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue : 0;
    };

    const row = dataItemTemp[selected];
    const recalculateAmountToBePaid = () => {
      if (row.description === "Other" && !isExporter) {
        row.itemTypeWhtAmountToBePaid = 0;
        return;
      }

      row.itemTypeWhtAmountToBePaid = roundAmt(
        toNum(row.itemTypeAmount) +
        toNum(row.itemTypeVatAmount) -
        toNum(row.itemTypeWhtAmount)
      );
    };

    if (e.target.name === "itemTypeVat") {
      const nextChecked = !Boolean(row.checkVat);
      row.checkVat = nextChecked;

      if (nextChecked) {
        row.itemTypeVat = 1;
        const baseForVat =
          toNum(row.itemTypeDppAmount) > 0
            ? toNum(row.itemTypeDppAmount)
            : toNum(row.itemTypeAmount);
        row.itemTypeVatAmount = roundAmt((toNum(row.itemTypeVatRate) / 100) * baseForVat);
      } else {
        row.itemTypeVat = 0;
        row.itemTypeTaxConfId = "";
        row.itemTypeVatRate = 0;
        row.itemTypeVatAmount = 0;
        row.itemTypeDppRate = 0;
        row.itemTypeDppAmount = 0;
      }

      recalculateAmountToBePaid();
    }

    else if (e.target.name === "itemTypeWht") {
      const nextChecked = !Boolean(row.checkWht);
      row.checkWht = nextChecked;

      if (nextChecked) {
        row.itemTypeWht = 1;
      } else {
        row.itemTypeWht = 0;
        row.itemTypeWhtType = "---";
        row.itemTypeWhtSubtype = "---";
        row.itemTypeWhtRate = 0;
        row.itemTypeWhtAmount = 0;
      }

      recalculateAmountToBePaid();
    }

    // mengambil data selected (isCheckbox true) dan ada perubahan data
    const findisCheckBoxTrue = dataItemTemp.filter((elem) => checkedItemType.find((e) => elem.id === e));
    const ammountToBePaidTemp = roundAmt(
      findisCheckBoxTrue.reduce((sum, item) => {
        return sum + ((item.description === "Other" && !isExporter) ? 0 : toNum(item.itemTypeWhtAmountToBePaid));
      }, 0)
    );
    let dataTempfindisCheckBoxTrue = []
    if (findisCheckBoxTrue.length >= 1) {
      findisCheckBoxTrue.forEach((d) => {
        dataTempfindisCheckBoxTrue.push({
          itemTypeNo: d.seq,
          itemTypeDesc: d.description,
          itemTypeAmount: Number(d.itemTypeAmount),
          itemTypeVat: d.itemTypeVat === null ? 0 : d.itemTypeVat,
          itemTypeTaxConfId: d.itemTypeTaxConfId === undefined ? "" : d.itemTypeTaxConfId,
          itemTypeVatRate: d.itemTypeVatRate,
          itemTypeVatAmount: Number(d.itemTypeVatAmount),
          itemTypeDppRate: d.itemTypeDppRate === undefined ? 0 : d.itemTypeDppRate,
          itemTypeDppAmount: Number(d.itemTypeDppAmount),
          itemTypeWht: d.itemTypeWht,
          itemTypeWhtType: d.itemTypeWhtType,
          itemTypeWhtSubtype: d.itemTypeWhtSubtype,
          itemTypeWhtRate: Number(d.itemTypeWhtRate),
          itemTypeWhtAmount: Number(d.itemTypeWhtAmount),
          Other: d.Other === null ? 0 : d.Other,
          itemTypeWhtAmountToBePaid: Number(d.itemTypeWhtAmountToBePaid),
        })
      })
    }


    setData({
      ...data,
      selectedItemType: dataTempfindisCheckBoxTrue,
      TotalAmountToBePaid: ammountToBePaidTemp
    })
    setItemType(dataItemTemp)
  }

  const [inputBilledQty, setBilledQtyInput] = useState({}); // key = row.id
  const filteredItemListRows = React.useMemo(
    () => filterItemListRows(data.ItemList, itemListFilterModel),
    [data.ItemList, itemListFilterModel]
  );

  const theColumns = [
    {
      field: " ",
      editable: false,
      filterable: false,
      width: 100,
      renderHeader: () => {
        return <Checkbox
          sx={{ color: "#FFFFFF" }}
          checked={checkAllListPO}
          indeterminate={indeterminateListPO}
          onChange={(e) => {
            setCheckAllListPO(e.target.checked);
            if (e.target.checked) {
              let newArray = [];

              const poSource = _usePoClientMode ? allPoRowsCache : listPoRows;
              poSource.forEach((dataPo) => {
                if (dataPo["isVisible"]) {
                  newArray.push(dataPo["id"]);
                  setIndetListPO(true);
                }
              })

              setCheckedListPO(newArray);
            } else {
              setCheckedListPO([]);
              setIndetListPO(false);
            }
          }}
          id="chk-all-list-po"
        />;
      },
      renderCell: (cellValues) => {
        return <Checkbox
          sx={{ marginLeft: "5px" }}
          checked={checkedListPO.includes(cellValues.row.id) ? true : false}
          id={"chk" + cellValues.row.id}
          disabled={cellValues.row.isVisible ? false : true}
          onChange={(e) => {
            if (e.target.checked) {
              let tempCheckedListPO = [...checkedListPO];
              tempCheckedListPO.push(cellValues.row.id);
              setCheckedListPO(tempCheckedListPO);
            } else {
              let tempCheckedListPO = [...checkedListPO];
              let foundID = tempCheckedListPO.find(p => p === cellValues.row.id);

              if (foundID !== undefined) {
                tempCheckedListPO = tempCheckedListPO.filter(p => p !== foundID);
              }

              setCheckedListPO(tempCheckedListPO);
            }
          }}
        />;
      },
    },
    {
      field: "poNo",
      headerName: "PO Number",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 140,
    },
    {
      field: "costCenter",
      headerName: "Cost Center",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "createBy",
      headerName: "SAP Created By",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 140,
    },
    {
      field: "paymentTerm",
      headerName: "Payment Term",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "paymentIn",
      headerName: "Payment In",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "companyCode",
      headerName: "Company Code",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "poType",
      headerName: "PO Type",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
      renderCell: (cellValues) => {
        switch (cellValues.row.poType) {
          case 0: return <p>Non Trade</p>
          case 1: return <p>Trade</p>
          default:
            return null
        }
      },
    },
    {
      field: "purchaseOrganization",
      headerName: "Purchasing Org",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "purchaseGroup",
      headerName: "Purch. Group",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "exchangeRate",
      headerName: "Exchange rate",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "incoterms",
      headerName: "Incoterms",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "incotermsDesc",
      headerName: "Incoterms Desc",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 200,
    },
  ];
  const columnItemList = [
    {
      field: " ",
      editable: false,
      filterable: false,
      width: 100,
      disableExport: true,
      renderHeader: () => {
        return <Checkbox
          sx={{ color: "#FFFFFF" }}
          checked={checkAllItemList}
          onChange={(e) => {
            setCheckAllItemList(e.target.checked);
            if (e.target.checked) {
              let newArray = [];

              data.ItemList.forEach((dataPo) => {
                newArray.push(dataPo["id"]);
              })
              setCheckedItemList(newArray);
            } else {
              setCheckedItemList([]);
            }
          }}
          id="chk-all-item-list"
        />;
      },
      renderCell: (cellValues) => {
        return <Checkbox
          sx={{ marginLeft: "5px" }}
          checked={checkedItemList.includes(cellValues.row.id) ? true : false}
          id={"chk" + cellValues.row.id}
          onChange={(e) => {
            if (e.target.checked) {
              let tempCheckedItemList = [...checkedItemList];
              tempCheckedItemList.push(cellValues.row.id);
              setCheckedItemList(tempCheckedItemList);
            } else {
              let tempCheckedItemList = [...checkedItemList];
              let foundID = tempCheckedItemList.find(p => p === cellValues.row.id);

              if (foundID !== undefined) {
                tempCheckedItemList = tempCheckedItemList.filter(p => p !== foundID);
              }

              setCheckedItemList(tempCheckedItemList);
            }
          }}
        />;
      },
    },
    {
      field: "poNo",
      headerName: "PO Number",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 140,
    },
    {
      field: "item",
      headerName: "Item",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 60,
    },
    {
      field: "awbInvoiceNo",
      headerName: "AWB/INV NO",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 160,
      renderCell: (cellValues) => {
        switch (cellValues.row.awbInvoiceNo) {
          case "NULL": return ""
          default:
            return cellValues.row.awbInvoiceNo
        }
      }
    },
    {
      field: "material",
      headerName: "Material",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 140,
    },
    {
      field: "shortText",
      headerName: "Short Text (Item)",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 160,
    },
    {
      field: "condition",
      headerName: "CnTy",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "conditionDesc",
      headerName: "Cnty Desc",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "quantity",
      headerName: "Qty",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
      renderCell: (cellValues) => {
        const raw = cellValues.row.quantity;

        // Handle string dengan koma seperti "6,9"
        let normalized = raw;
        if (typeof raw === "string" && raw.includes(",")) {
          normalized = parseFloat(raw.replace(",", "."));
        }

        return (
          <NumberFormat
            value={normalized}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2} // Boleh sampai 2 desimal, tapi tidak wajib
          />
        );
      },
    }
    ,
    {
      field: "currency",
      headerName: "Curr",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 60,
    },
    {
      field: "netValue",
      headerName: "Net Value",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
      renderCell: (cellValues) => {
        if (cellValues.row.netValue !== null && cellValues.row.netValue !== undefined) {
          return <NumberFormat displayType="text" decimalScale={2} thousandSeparator="." decimalSeparator="," value={cellValues.row.netValue} />
        }
      },
    },
    {
      field: "itemStatus",
      headerName: "Item Status",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 140,
      renderCell: (cellValues) => {
        switch (cellValues.row.itemStatus) {
          case "NULL": return ""
          default:
            return cellValues.row.itemStatus
        }
      }
    },
    {
      field: "grStatus",
      headerName: "GR Status",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {

      field: "billedQty",
      headerName: "Billed Qty",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 90,
      renderCell: (cellValues) => {
        const row = cellValues.row;
        const rowId = row.id;

        const rawInput = inputBilledQty[rowId] ?? (
          typeof row.billedQty === "number"
            ? row.billedQty.toString().replace(".", ",")
            : ""
        );

        const handleInputChange = (e) => {
          const val = e.target.value;
          // Simpan input mentah
          setBilledQtyInput((prev) => ({ ...prev, [rowId]: val }));

          // Kirim ke handler utama
          handleChangeBilledQty(e, row);
        };

        return (
          <input
            value={rawInput}
            onChange={handleInputChange}
            className="input-BilledQty"
            id={`billedQty-${row.id}`}
            name="billedQty"
            type="text"
            inputMode="decimal"
            onPaste={preventPasteNegative}
            onKeyPress={preventMinus}
            style={{ width: "100%", padding: "4px", textAlign: "right" }}
          />
        );
      },

    }

    ,
    {
      field: "amountInvoice",
      headerName: "Amount Inv.",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 160,
      disableExport: true,
    },
  ];
  const isOtherItemType = (row) => row.description === "Other";
  const hasOtherWithAmount = dataItemType?.some(
    (item) => item.description === "Other" && Number(item.itemTypeAmount) !== 0
  );
  const isCheckedItemTypeRow = (row) => checkedItemType.includes(row.id);
  const isSubtotalItemTypeRow = (row) => row.description === "Material" || row.description === "Services";
  const hasItemTypeAmount = (row) =>
    row.itemTypeAmount !== "" && row.itemTypeAmount !== null && Number(row.itemTypeAmount) !== 0;
  const shouldWarnItemTypeAmount = (row) => {
    return (
      data.TotalAmountItemType === true &&
      !(hasOtherWithAmount && isExporter) &&
      isCheckedItemTypeRow(row) &&
      isSubtotalItemTypeRow(row) &&
      hasItemTypeAmount(row)
    );
  };
  const shouldMarkValidItemTypeAmount = (row) =>
    isCheckedItemTypeRow(row) &&
    isSubtotalItemTypeRow(row) &&
    hasItemTypeAmount(row) &&
    !shouldWarnItemTypeAmount(row);
  const getItemTypeAmountClass = (row) => {
    if (shouldWarnItemTypeAmount(row)) return "input-amountType-warning";
    if (shouldMarkValidItemTypeAmount(row)) return "input-amountType-valid";
    return "input-amountType";
  };
  const amountNumberFormat = getNumberFormatConfig(currency?.[0]);

  const columnItemType = [
    {
      field: " ",
      editable: false,
      filter: false,
      width: 100,
      renderHeader: () => {
        let disableChkAllItemType = true;
        dataItemType.forEach((dataPo) => {
          if (dataPo.itemTypeAmount !== 0 && dataPo.itemTypeAmount !== null) {
            disableChkAllItemType = false;
          }
        })
        return <Checkbox
          sx={{ color: "#FFFFFF" }}
          checked={checkAllItemType}
          disabled={disableChkAllItemType}
          indeterminate={indeterminateItemType}
          onChange={(e) => {
            setCheckAllItemType(e.target.checked);
            if (e.target.checked) {
              let newArray = [];

              dataItemType.forEach((dataPo) => {
                //check only all item type with amount not null
                if (dataPo.itemTypeAmount !== "" && dataPo.itemTypeAmount !== null) {
                  newArray.push(dataPo["id"]);
                } else {
                  setIndeterminateItemType(true);
                }
              })

              setCheckedItemType(newArray);
            } else {
              setCheckedItemType([]);
            }
          }}
          id="chk-all-item-type"
        />;
      },
      renderCell: (cellValues) => {
        return <Checkbox
          sx={{ marginLeft: "5px" }}
          checked={checkedItemType.includes(cellValues.row.id) ? true : false}
          disabled={cellValues.row.itemTypeAmount === 0 || cellValues.row.itemTypeAmount === "" || cellValues.row.itemTypeAmount === null ? true : false}
          id={"chk" + cellValues.row.id}
          onChange={(e) => {
            // handleCheckBox(e, cellValues.row)
            if (e.target.checked) {
              //set row id to checked item type list
              if (cellValues.row.itemTypeAmount !== "" && cellValues.row.itemTypeAmount !== null && cellValues.row.itemTypeAmount !== 0) {
                let tempCheckedItemType = [...checkedItemType];
                tempCheckedItemType.push(cellValues.row.id);
                setCheckedItemType(tempCheckedItemType);
              }
            } else {
              //unset row id from checked item type list
              let tempCheckedItemType = [...checkedItemType];
              let foundID = tempCheckedItemType.find(p => p === cellValues.row.id);

              if (foundID !== undefined) {
                tempCheckedItemType = tempCheckedItemType.filter(p => p !== foundID);
              }

              setCheckedItemType(tempCheckedItemType);
            }
          }}
        />;
      },
    },
    {
      field: "description",
      headerName: "Item Type",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 160,
    },
    {

      field: "itemTypeAmount",
      headerName: "Amount",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
      renderCell: (cellValues) => {
        const rowId = cellValues.row.id;
        const hasDraftValue = Object.prototype.hasOwnProperty.call(inputItemTypeAmount, rowId);
        const inputValue = hasDraftValue
          ? inputItemTypeAmount[rowId]
          : formatLocalAmount(cellValues.row.itemTypeAmount);

        return (
          <TextField
            onChange={(e) => {
              const rawValue = e.target.value;
              setInputItemTypeAmount((prev) => ({ ...prev, [rowId]: rawValue }));
              handleChangeItemType(
                { target: { name: "itemTypeAmount", value: parseFlexibleAmount(rawValue) } },
                cellValues.row
              );
            }}
            onBlur={() => {
              setInputItemTypeAmount((prev) => {
                const next = { ...prev };
                delete next[rowId];
                return next;
              });
            }}
            margin="none"
            InputProps={{
              className: getItemTypeAmountClass(cellValues.row),
            }}
            inputProps={{
              inputMode: "decimal",
              style: { textAlign: "right" },
            }}
            name="itemTypeAmount"
            size="small"
            value={inputValue}
            onPaste={(e) => {
              if ((cellValues.row.description === "Other" || cellValues.row.itemTypeDesc === "Other") && isExporter) {
                // allow negative paste
              } else {
                preventPasteNegative(e);
              }
            }}
            onKeyPress={(e) => {
              if ((cellValues.row.description === "Other" || cellValues.row.itemTypeDesc === "Other") && isExporter) {
                // allow minus
              } else {
                preventMinus(e);
              }
            }}

          />
        );
      },
    },
    {
      field: "itemTypeVat",
      headerName: "VAT",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minWidth: 80,
      renderCell: (cellValues) => {
        const row = cellValues.row;
        if (isOtherItemType(row)) return "";

        return (
          <Checkbox
            name="itemTypeVat"
            disabled={row.itemTypeAmount === 0 || row.itemTypeAmount === null}
            checked={row.checkVat}
            onChange={(e) => handleCheckBox(e, row)}
          />
        );
      },
    },
    {
      field: "itemTypeDppAmount",
      headerName: "DPP Amount",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 200,
      renderCell: (cellValues) => {
        const row = cellValues.row;

        // "Other" → tampil "-" tanpa input (rata kanan)
        if (isOtherItemType(row)) {
          return (
            <div style={{ width: "100%", textAlign: "right", paddingRight: 8 }}>
              -
            </div>
          );
        }

        const isDisabled = row.itemTypeVat === null || row.itemTypeVat === 0;
        const value =
          Number.isFinite(Number(row.itemTypeDppAmount))
            ? Number(row.itemTypeDppAmount)
            : "";

        return (
          <TextField
            type="number"
            name="itemTypeDppAmount"
            disabled={isDisabled}
            value={value}
            size="small"
            margin="none"
            onChange={(e) => handleChangeItemType(e, row)}
            inputProps={{ style: { textAlign: "right" } }}
            // jika perlu mencegah minus:
            onKeyPress={preventMinus}
            onPaste={preventPasteNegative}
          />
        );
      },
    }
    ,

    {
      field: "itemListVatRate",
      headerName: "VAT Rate",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 200,
      renderCell: (cellValues) => {
        //console.log(cellValues.row)
        switch (cellValues.row.vat) {
          case 1:
            return (
              <select
                disabled={!cellValues.row.checkVat}
                name="itemTypeTaxConfId"
                className="form-select w-100"
                value={cellValues.row.itemTypeTaxConfId || ""}
                onChange={(e) => {
                  let taxs = handleTaxConfig(e.target.value, cellValues.row.itemTypeAmount)
                  //console.log(taxs)
                  cellValues.row.itemTypeVatRate = taxs.vatRate
                  // cellValues.row.itemTypeDppRate = taxs.dppRate
                  cellValues.row.itemTypeTaxConfId = e.target.value ?? null
                  handleChangeItemType(e, cellValues.row, taxs.vatRate)
                }}
                id={"taxConf-" + cellValues.row.id}
              >
                {dropdownTaxConfig.map((status, key) => (
                  <option key={"taxConfId-" + key} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            )
          default:
            return null
        }
      },
    },
    {
      field: "itemTypeVatAmount",
      headerName: "VAT Amount",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 160,
      renderCell: (cellValues) => {
        switch (cellValues.row.vat) {
          case 1:
            <Input type="hidden" name="itemTypeVatAmount" value={Number(cellValues.row.itemTypeVatAmount)} disabled />
            return (
              <NumberFormat displayType="text" decimalScale={2} thousandSeparator="." decimalSeparator="," value={cellValues.row.itemTypeVatAmount} />
            )
          default:
            return null;
        }
      },
    },
    {
      field: "itemTypeWht",
      headerName: "Wht",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 80,
      renderCell: (cellValues) => {
        switch (cellValues.row.wht) {
          case 1: return <Checkbox disabled={data.TaxType === "nonTaxable" || data.TaxType === "" || cellValues.row.itemTypeAmount === 0 || cellValues.row.itemTypeAmount === null ? true : false} name="itemTypeWht" checked={cellValues.row.checkWht} onChange={(e) => handleCheckBox(e, cellValues.row)} />
          default:
            return null
        }
      },
    },
    {
      field: "whtType",
      headerName: "Wht Type",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
      renderCell: (cellValues) => {
        switch (cellValues.row.wht) {
          case 1:
            return (
              <select disabled={!cellValues.row.checkWht} name="whtType" className="select-item-Type"
                onChange={(e) => {
                  // setSelectedTempItemType(cellValues.row)
                  handleFormChange(e, cellValues.row)

                }}
                id={"whttype-" + cellValues.row.id}
              >
                {dropdownWhtType.map((status, key) => (
                  <option key={"whttype-" + key} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            )
          default:
            return null
        }
      },
    },
    {
      field: "whtSubType",
      headerName: "Wht Sub Type",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 300,
      renderCell: (cellValues) => {

        switch (cellValues.row.wht) {
          case 1:
            return (
              <Autocomplete
                disablePortal
                onChange={(e, newValue) => {

                  if (newValue !== null) {
                    const dataItemTemp = dataItemType
                    const selected = dataItemTemp.findIndex((row) => row.id === cellValues.row.id)
                    let ammountToBePaid = []
                    let whtRate = null
                    let whtRateFilter = dropdownWht.filter((d) => {
                      return d.companyCode === data.companyCode && d.taxType === data.whtType && d.serviceType === newValue.serviceType
                    });

                    if (whtRateFilter.length >= 1) {
                      let vatRegistration = listInfoVendor[0].vatRegistration
                      if (vatRegistration !== null && vatRegistration !== "") {
                        whtRate = whtRateFilter[0].npwpRate
                      } else {
                        whtRate = whtRateFilter[0].nonNpwpRate
                      }
                    }
                    dataItemTemp[selected].itemTypeWhtSubtype = newValue.serviceType
                    dataItemTemp[selected].itemTypeWhtRate = Number(whtRate * 100)

                    if (currency !== null && currency !== undefined) {
                      if (currency[0] === "IDR") {
                        dataItemTemp[selected].itemTypeWhtAmount = Math.ceil((Number(whtRate) * dataItemTemp[selected].itemTypeAmount))
                        dataItemTemp[selected].itemTypeWhtAmountToBePaid = Math.ceil(dataItemTemp[selected].itemTypeAmount + Number(dataItemTemp[selected].itemTypeVatAmount) - Number(dataItemTemp[selected].itemTypeWhtAmount))

                      } else {
                        dataItemTemp[selected].itemTypeWhtAmount = (Number(whtRate) * dataItemTemp[selected].itemTypeAmount).toFixed(2)
                        dataItemTemp[selected].itemTypeWhtAmountToBePaid = (dataItemTemp[selected].itemTypeAmount + Number(dataItemTemp[selected].itemTypeVatAmount) - Number(dataItemTemp[selected].itemTypeWhtAmount)).toFixed(2)

                      }
                    } else {
                      dataItemTemp[selected].itemTypeWhtAmount = (Number(whtRate) * dataItemTemp[selected].itemTypeAmount).toFixed(2)
                      dataItemTemp[selected].itemTypeWhtAmountToBePaid = (dataItemTemp[selected].itemTypeAmount + Number(dataItemTemp[selected].itemTypeVatAmount) - Number(dataItemTemp[selected].itemTypeWhtAmount)).toFixed(2)
                    }

                    let filterSelected = dataItemTemp.filter(function (o1) {
                      return data.selectedItemType.some(function (o2) {
                        return o1.description === o2.itemTypeDesc;
                      });
                    })

                    filterSelected.forEach((data) => ammountToBePaid.push(Number(data.itemTypeWhtAmountToBePaid)))
                    let ammountToBePaidTemp = Number(ammountToBePaid.slice(0, 2).reduce((a, b) => a + b, 0))

                    const selectedTemp = []
                    filterSelected.forEach((d) => {
                      selectedTemp.push({
                        itemTypeNo: d.seq,
                        itemTypeDesc: d.description,
                        itemTypeAmount: Number(d.itemTypeAmount),
                        itemTypeTaxConfId: d.itemTypeTaxConfId === undefined ? "" : d.itemTypeTaxConfId,
                        itemTypeVat: d.itemTypeVat === null ? 0 : d.itemTypeVat,
                        itemTypeVatRate: d.itemTypeVatRate,
                        itemTypeVatAmount: Number(d.itemTypeVatAmount),
                        itemTypeDppRate: d.itemTypeDppRate === undefined ? 0 : d.itemTypeDppRate,
                        itemTypeDppAmount: Number(d.itemTypeDppAmount),
                        itemTypeWht: d.itemTypeWht,
                        itemTypeWhtType: d.itemTypeWhtType,
                        itemTypeWhtSubtype: d.itemTypeWhtSubtype,
                        itemTypeWhtRate: Number(d.itemTypeWhtRate),
                        itemTypeWhtAmount: Number(d.itemTypeWhtAmount),
                        Other: d.Other === null ? 0 : d.Other,
                        itemTypeWhtAmountToBePaid: Number(d.itemTypeWhtAmountToBePaid),
                      });
                    })

                    setData({
                      ...data,
                      selectedItemType: selectedTemp,
                      TotalAmountToBePaid: ammountToBePaidTemp
                    })
                    setItemType(dataItemTemp)
                  }

                }}
                options={dropdownWhtSubType}
                renderOption={(props) => (
                  <Tooltip title={props.key} placement="bottom">
                    <li {...props}>{props.key}</li>
                  </Tooltip>
                )}
                id="whtSubType"
                name="whtSubType"
                getOptionLabel={(option) => option.label}
                size="small"
                disabled={!cellValues.row.checkWht}
                renderInput={(params) => <TextField {...params} size="small" label="" />}
                sx={{ width: 300 }}
                value={dropdownWht.find((d) => d.companyCode === data.companyCode && d.taxType === cellValues.row.itemTypeWhtType && d.serviceType === cellValues.row.itemTypeWhtSubtype) !== undefined ?
                  dropdownWht.find((d) => d.companyCode === data.companyCode && d.taxType === cellValues.row.itemTypeWhtType && d.serviceType === cellValues.row.itemTypeWhtSubtype) : null}
              />
            )
          default:
            return null
        }
      },
    },
    {
      field: "itemTypeWhtRate",
      headerName: "Wht Rate",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
      renderCell: (cellValues) => {
        switch (cellValues.row.wht) {
          case 1:
            return (
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  disabled={data.TaxType === "nonTaxable" || data.TaxType === "" || cellValues.row.itemTypeAmount === 0 || cellValues.row.itemTypeAmount === null ? true : false}
                  value={cellValues.row.itemTypeWhtRate}
                  onChange={(e) => handleChangeItemType(e, cellValues.row)}
                  className="input-BilledQty"
                  id="itemTypeWhtRate"
                  name="itemTypeWhtRate"
                  type="number"
                  onPaste={preventPasteNegative}
                  onKeyPress={preventMinus}
                />
                <p style={{ marginLeft: "20px" }}>%</p>
              </div>
            )

          default:
            return <p></p>;
        }
      }
    },
    {
      field: "itemTypeWhtAmount",
      headerName: "Wht Amount",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 160,
      renderCell: (cellValues) => {
        switch (cellValues.row.wht) {
          case 1:
            return (
              <input
                value={cellValues.row.itemTypeWhtAmount}
                onChange={(e) => handleChangeItemType(e, cellValues.row)}
                className="input-BilledQty"
                id="itemTypeWhtAmount"
                name="itemTypeWhtAmount"
                type="number"
                onPaste={preventPasteNegative}
                onKeyPress={preventMinus}
              />
            )
          default:
            return <p></p>;
        }
      }
    },
    {
      field: "itemTypeWhtAmountToBePaid",
      headerName: "Amount To Be Paid",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 140,
      renderCell: (cellValues) => {
        const dataCurr = currency
        let data = cellValues.row.itemTypeWhtAmountToBePaid
        if (dataCurr !== null && dataCurr !== undefined) {
          if (dataCurr[0] !== null) {
            data = Number(cellValues.row.itemTypeWhtAmountToBePaid)
          } else {
            data = Number(cellValues.row.itemTypeWhtAmountToBePaid).toFixed(2)
          }
        }

        return <NumberFormat displayType="text" decimalScale={2} thousandSeparator="." decimalSeparator="," value={data} />
      }
    },
  ];



  const theColumnsError = [
    {
      field: "error_Description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 500,
    },
    {
      field: "purchaseNo",
      headerName: "PO Number",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 120,
    },
    {
      field: "item",
      headerName: "Item",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 80,
    },
    {
      field: "balanceQty",
      headerName: "Balance Qty",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 100,
    },
    {
      field: "billedQty",
      headerName: "Billed Qty",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 100,
    },


  ];

  const [TopInstallmentDetail, setTopInstallmentDetail] = useState([]);
  const columnInstallment = [
    {
      field: "installment",
      headerName: "Installment",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 200,
    },
    {
      field: "dueDate",
      headerName: "Due Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 500,
      renderCell: (cellValues) => {
        const currentDate = new Date().toISOString().split('T')[0];
        return (
          <input
            className="input-instalment"
            id="dueDate"
            name="dueDate"
            type="date"
            min={currentDate}
            defaultValue={cellValues.row.dueDate}
            onChange={(e) => handleInstallment(e, cellValues.row.id)}
            onKeyDown={(e) => e.preventDefault()}
          />
        );
      },
    },
    {
      field: "amount",
      headerName: "Amount",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 490,
      renderCell: (cellValues) => {
        return (
          <TextField
            onChange={(e) => handleInstallment(e, cellValues.row.id)}
            margin="none"
            InputProps={{
              inputComponent: NumberFormatCustom,
              className: data.TotalAmountInstallment === true ? "input-amountType-warning" : "input-amountType"
            }}
            inputProps={amountNumberFormat}
            name="amount"
            size="small"
            defaultValue={cellValues.row.amount}
          />
        );
      },
    },
  ];

  const handleInstallment = (e, dataId) => {
    let valueInstallment = e.target.name === "amount" ? RemoveFormatting(e.target.value, currency?.[0]) : e.target.value
    let ammountTemp = []

    const newData = TopInstallmentDetail
    const selected = newData.findIndex((d) => d.id === dataId)
    newData[selected][e.target.name] = valueInstallment
    let detailTemp = []
    newData.forEach((d) => {
      detailTemp.push({
        installment: d.installment,
        dueDate: d.dueDate,
        amount: Number(d.amount)
      })
      ammountTemp.push(Number(d.amount))
    })
    let amount = ammountTemp.reduce((a, b) => a + b, 0).toFixed(2)

    let ammountToBePaid = data.TotalAmountToBePaid === null ? 0 : data.TotalAmountToBePaid.toFixed(2);
    if (amount < ammountToBePaid || amount > ammountToBePaid) {
      setData({
        ...data,
        TotalAmountInstallment: true,
        TopInstallmentDetail: detailTemp
      })
    } else {
      setData({
        ...data,
        TotalAmountInstallment: false,
        TopInstallmentDetail: detailTemp
      })
    }

    // setData({
    //   ...data,
    //   TopInstallmentDetail:detailTemp
    // })
    setTopInstallmentDetail(newData)
  }


  const handleClick = (e) => {
    setSelectTemp(e)
    hiddenFileInput.current.click();
  };

  const handleUpload = (event) => {
    const dataTemp = attachSupportDoc
    const selected = dataTemp.findIndex((row) => row.idDocSetting === selectTemp.idDocSetting)
    if (event.target.files.length >= 1) {
      dataTemp[selected].fileName = event.target.files[0].name
      dataTemp[selected].fileSupporting = event.target.files[0]
      dataTemp[selected].upload = true
      setAttachSupportDoc(dataTemp)
      let payloadAttach = []
      dataTemp.forEach((d) => {
        payloadAttach.push({
          DocSettingId: d.idDocSetting,
          DocumentNo: d.documentNo,
          FileSupporting: d.fileSupporting
        })
      })
      setData({
        ...data,
        attachment: payloadAttach
      })

    }
  };

  const handleDeleteFile = (dataSelect) => {
    setSelectTemp(dataSelect)
    const dataTemp = attachSupportDoc
    const selected = dataTemp.findIndex((row) => row.idDocSetting === dataSelect.idDocSetting)
    dataTemp[selected].fileName = null
    dataTemp[selected].fileSupporting = null
    dataTemp[selected].upload = false
    setAttachSupportDoc(dataTemp)

    let payloadAttach = []
    dataTemp.forEach((d) => {
      payloadAttach.push({
        DocSettingId: d.idDocSetting,
        DocumentNo: d.documentNo,
        FileSupporting: d.fileSupporting
      })
    })
    setData({
      ...data,
      attachment: payloadAttach
    })
  };

  const handleDocumentNo = (e, dataSelected) => {
    let dataTemp = attachSupportDoc
    let selected = dataTemp.findIndex((row) => row.idDocSetting === dataSelected.idDocSetting)
    dataTemp[selected][e.target.name] = e.target.value.length > 0 ? e.target.value : null
    setAttachSupportDoc(dataTemp)
    let payloadAttach = []
    dataTemp.forEach((d) => {
      payloadAttach.push({
        DocSettingId: d.idDocSetting,
        DocumentNo: d.documentNo,
        FileSupporting: d.fileSupporting
      })
    })
    setData({
      ...data,
      attachment: payloadAttach
    })
  }
  const columnSupportDoc = [
    {
      field: "documentName",
      headerName: "Document Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 490,
      renderCell: (cellValues) => {
        // validate doc
        // 1.semua vendor validate hanya invoice number
        // 2. jika local validate 1-4 (invoice vendor,faktur pajak,surat jalan,BAST)
        // 3.vendor freight validate 5-12
        // const dataVendor = listInfoVendor[0].countryCode
        // if (dataVendor !== "ID") {

        // }
        return <p className={cellValues.row.mandatory === true ? "mandatory-doc" : undefined}>{cellValues.row.documentName}</p>

      }

    },
    {
      field: "documentNo",
      headerName: "Document No",
      headerClassName: "super-app-theme--header",
      editable: false,
      width: 190,
      renderCell: (cellValues) => {
        return <input className="input-document-no" name="documentNo" value={cellValues.row.documentNo || ""} onChange={(e) => handleDocumentNo(e, cellValues.row)} />
      }
    },
    {
      field: "fileName",
      headerName: "Upload File",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 290,
      renderCell: (cellValues) => {
        return (
          <p className="uploadFile-name" >{cellValues.row.fileName}</p>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      editable: false,
      flex: 1,
      minwidth: 290,

      renderCell: (cellValues) => {
        return (
          <div style={{ display: "flex" }}>
            <p className="text-upload-file" onClick={() => handleClick(cellValues.row)}>{cellValues.row.upload === false ? "Upload File" : "Replace File"}</p>
            <p className="delete-upload-text" onClick={() => handleDeleteFile(cellValues.row)} >{cellValues.row.upload === true && "Delete"}</p>
            <input
              id="fileAttach"
              name="fileAttach"
              type="file"
              style={{ display: 'none' }}
              ref={hiddenFileInput}
              onChange={(event) => handleUpload(event)}

            />
          </div>
        );
      },
    },
  ];

  const handleBack = () => {
    dispatch({
      type: "LIST_PO",
      payload: [],
    });
    dispatch({
      type: "ITEM_LIST_PO",
      payload: [],
    });
    dispatch(changeScreenIS("list-is"));

  };

  const handleIncreaseBtn = (number) => {
    number += 1;
    setData({
      ...data,
      TopInstallment: parseInt(number),
    });
    setTopInstallmentDetail([
      ...TopInstallmentDetail,
      {
        id: number,
        installment: number,
        dueDate: null,
        amount: null,
      },
    ]);
  };
  const handleDecreaseBtn = (number) => {
    number -= 1;
    if (number >= 0) {
      setData({
        ...data,
        TopInstallment: parseInt(number),
      });
      const newArr = [...TopInstallmentDetail];
      newArr.splice(-1);
      setTopInstallmentDetail(newArr);
    } else {
      Toastify({
        text: "installments must be more than 0",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top",
        position: "right",
        // stopOnFocus: true,
        style: {
          background: "#CB605A",
        },
      }).showToast();
    }
  };

  const preventMinus = (e) => {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };
  const preventPasteNegative = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = parseFloat(clipboardData.getData("text"));

    if (pastedData < 0) {
      e.preventDefault();
    }
  };


  const handleSave = (type) => {
    if (type === "save") {
      setLoadingSave(true);
    } else if (type === "submit") {
      setLoadingSubmit(true);
    }

    const selectedItemTypeRows = dataItemType.filter(
      (row) => checkedItemType.includes(row.id) && Number(row.itemTypeAmount || 0) !== 0
    );

    const selectedItemTypeForSubmit = selectedItemTypeRows.map((d) => ({
      itemTypeNo: d.seq,
      itemTypeDesc: d.description,
      itemTypeAmount: Number(d.itemTypeAmount || 0),
      itemTypeTaxConfId: d.itemTypeTaxConfId === undefined ? "" : d.itemTypeTaxConfId,
      itemTypeVat: d.itemTypeVat === null ? 0 : d.itemTypeVat,
      itemTypeVatRate: d.itemTypeVatRate === null ? 0 : d.itemTypeVatRate,
      itemTypeVatAmount: d.itemTypeVatAmount === null ? 0 : Number(d.itemTypeVatAmount),
      itemTypeDppRate: d.itemTypeDppRate === undefined ? 0 : d.itemTypeDppRate,
      itemTypeDppAmount: d.itemTypeDppAmount === null ? 0 : Number(d.itemTypeDppAmount),
      itemTypeWht: d.itemTypeWht,
      itemTypeWhtType: d.itemTypeWhtType,
      itemTypeWhtSubtype: d.itemTypeWhtSubtype,
      itemTypeWhtRate: d.itemTypeWhtRate === null ? 0 : Number(d.itemTypeWhtRate),
      itemTypeWhtAmount: d.itemTypeWhtAmount === null ? 0 : Number(d.itemTypeWhtAmount),
      itemTypeWhtAmountToBePaid: d.itemTypeWhtAmountToBePaid === null ? 0 : Number(d.itemTypeWhtAmountToBePaid),
    }));

    const selectedItemTypePaymentTotal = selectedItemTypeRows
      .filter((d) => d.description !== "Other" || isExporter)
      .reduce((sum, d) => sum + Number(d.itemTypeWhtAmountToBePaid || 0), 0);
    const normalizedTotalAmountToBePaid = normalizeCurrencyAmount(selectedItemTypePaymentTotal, currency?.[0]);
    const rawInstallmentDetails =
      Array.isArray(TopInstallmentDetail) && TopInstallmentDetail.length > 0
        ? TopInstallmentDetail
        : Array.isArray(data.TopInstallmentDetail)
          ? data.TopInstallmentDetail
          : [];
    const normalizedInstallmentDetails = rawInstallmentDetails.map((item, index) => ({
      ...item,
      installment: item.installment || item.Installment || index + 1,
      dueDate: item.dueDate || item.DueDate || null,
      amount: normalizeCurrencyAmount(RemoveFormatting(item.amount ?? item.Amount, currency?.[0]), currency?.[0]),
    }));
    const installmentTotal = normalizeCurrencyAmount(
      normalizedInstallmentDetails.reduce((sum, item) => sum + Number(item.amount || 0), 0),
      currency?.[0]
    );
    const topInstallmentCount = Number(data.TopInstallment || normalizedInstallmentDetails.length || 0);
    const installmentTolerance = currency?.[0] === "IDR" ? 0 : 0.01;
    const isInstallmentValid =
      data.TopType !== "Installment" ||
      (
        topInstallmentCount > 0 &&
        normalizedInstallmentDetails.length === topInstallmentCount &&
        normalizedInstallmentDetails.every((item) => Number(item.amount || 0) >= 0 && (Number(item.amount || 0) === 0 || (item.dueDate && item.dueDate !== ''))) &&
        Math.abs(installmentTotal - normalizedTotalAmountToBePaid) <= installmentTolerance
      );

    // Remove 'id' from selectedItemList
    let cleanedSelectedItemList = [...data.selectedItemList];
    cleanedSelectedItemList.forEach(selItemList => {
      delete selItemList.id;
    });

    // Build new payload
    const newData = {
      InvoiceStatus: type === "save" ? 0 : type === "submit" ? 1 : null,
      TotalAmountToBePaid: normalizedTotalAmountToBePaid.toFixed(2),
      VendorInvoiceNumber: data.VendorInvoiceNumber,
      InvoiceDate: moment(today).format("YYYY-MM-DD"),
      POType: data.poType,
      PaymentTerm: data.paymentTerm,
      PaymentType: data.PaymentType,
      TaxType: data.TaxType,
      CompanyCode: data.companyCode,
      VendorCode: listInfoVendor[0].vendorCode,
      ListPOHdr: selectListPo,
      ItemList: cleanedSelectedItemList.length > 0 ? cleanedSelectedItemList : null,
      ItemTypeList: selectedItemTypeForSubmit.length > 0 ? selectedItemTypeForSubmit : null,
      TopType: data.TopType,
      TopInstallment: data.TopInstallment,
      TopInstallmentDetail: normalizedInstallmentDetails.length > 0 ? normalizedInstallmentDetails : null,
      BankName: data.BankName,
      BankAccountNo: data.BankAccountNo || "",
      BankAccountName: data.BankAccountName || "",
      TopDueDate: data.TopDueDate !== null ? moment(data.TopDueDate).format("YYYY-MM-DD") : null,
      TopPercentage: data.TopPercentage,
      TopAmount: data.TopAmount,
      // Hanya kirim dokumen yang punya file atau nomor dokumen — jangan kirim slot kosong
      SupportingDocuments: data.attachment.length > 0
        ? data.attachment.filter(d => d.FileSupporting !== null || (d.DocumentNo && d.DocumentNo !== 'null'))
        : null

    };

    // Convert to FormData
    const formData = new FormData();
    for (let key in newData) {
      if (Array.isArray(newData[key])) {
        newData[key].forEach((obj, index) => {
          Object.keys(obj).forEach((keyItem) => {
            const keyName = `${key}[${index}].${keyItem}`;
            formData.append(keyName, obj[keyItem]);
          });
        });
      } else if (typeof newData[key] === "object" && newData[key] !== null) {
        Object.keys(newData[key]).forEach((innerKey) => {
          formData.append(`${key}.${innerKey}`, newData[key][innerKey]);
        });
      } else {
        formData.append(key, newData[key]);
      }
    }

    // Clean up null object arrays
    ["ItemList", "ListPOHdr", "ItemTypeList", "TopInstallmentDetail", "SupportingDocuments"].forEach((key) => {
      if (formData.get(key) === "null") formData.delete(key);
    });

    // Check if mandatory supporting documents are uploaded
    const filterMandatoryFile = attachSupportDoc.filter(d => d.mandatory === true);
    const allTrue = filterMandatoryFile.every(obj => obj.fileSupporting !== null && obj.documentNo !== null);

    // === VALIDATION LOGIC ===
    const hasOtherWithAmount = data.selectedItemType?.some(
      (item) => item.itemTypeDesc === "Other" && Number(item.itemTypeAmount) !== 0
    );

    // helper: normalisasi status & deteksi timeout/server
    const getErrorStatus = (err) =>
      err?.response?.status ?? err?.status ?? err?.data?.status ?? err?.data?.statusCode ?? null;

    const isServerOrTimeout = (err) => {
      const status = getErrorStatus(err);
      const msg = String(err?.response?.statusText || err?.data?.message || err?.message || "").toLowerCase();
      return (
        // status === 408 || status === 502 || status === 503 || 
        status === 504
        // ||(typeof status === "number" && status >= 500) ||
        // msg.includes("timeout") || msg.includes("time-out") ||
        // msg.includes("gateway time-out") || msg.includes("network error") ||
        // msg.includes("failed to fetch") || status == null
      );
    };

    const extractCreatedPaymentReqNo = (res) => {
      // Backend returns: { message: "...", data: { paymentReqNo: "..." } }
      // Axios wraps it as res.data = { message, data }
      const payload = res?.data || {};
      return (
        payload.data?.paymentReqNo ||
        payload.data?.PaymentReqNo ||
        payload.Data?.paymentReqNo ||
        payload.Data?.PaymentReqNo ||
        payload.paymentReqNo ||
        payload.PaymentReqNo ||
        ""
      );
    };

    // helper: balik ke list screen (Redux only)
    const goListScreen = (toastMsg = "Koneksi sedang tidak stabil, silahkan refresh dan kembali beberapa saat lagi") => {
      dispatch(changeScreenIS("list-is")); // <-- ini yang kamu minta
      Toastify({
        text: toastMsg,
        duration: 3000,
        gravity: "top",
        text: toastMsg,
        duration: 3000,
        gravity: "top",
        position: "right",
        style: { background: "#CB605A" },
      }).showToast();
    };

    const FALLBACK_MSG = "Koneksi sedang tidak stabil, silahkan refresh dan kembali beberapa saat lagi";

    const getValidationErrorMsg = (amountOk, topOk, installmentOk, materialOk) => {
      if (!materialOk) return "The Amount of Material or Service Must Be Equal to Subtotal Amount Before Tax";
      if (!topOk) return "The Amount of Term of payment can't be more than Subtotal Amount Before Tax";
      if (!installmentOk) return "The Amount of installment Must Be Equal to amount to be paid";
      if (!amountOk) return "Mismatch between item amount and subtotal before tax";
      return "Validation failed";
    };


    const selectedHasOtherWithAmount = selectedItemTypeRows.some(
      (item) => item.description === "Other" && Number(item.itemTypeAmount || 0) !== 0
    );
    const selectedMaterialServiceTotal = selectedItemTypeRows
      .filter((item) => item.description === "Material" || item.description === "Services" || item.description === "Other")
      .reduce((sum, item) => sum + Number(item.itemTypeAmount || 0), 0);
    const itemTypeExpectedTotal =
      data.PaymentType === "Advanced Payment" ? Number(data.TopAmount || 0) : Number(data.TotalAmountBeforeTax || 0);

    const isAmountValid =
      selectedHasOtherWithAmount || isSameCurrencyAmount(selectedMaterialServiceTotal, itemTypeExpectedTotal, currency?.[0]);

    const isTopPercentageValid = data.TopPercentageCondition !== true;

    const isServiceMaterialFilled = normalizeCurrencyAmount(selectedMaterialServiceTotal, currency?.[0]) !== 0;

    // === Blok SAVE (fixed) ===
    if (type === "save") {
      if (isAmountValid && isTopPercentageValid && isInstallmentValid && isServiceMaterialFilled) {
        dispatch(createInvoice(formData))
          .then(() => {
            setLoadingSave(false);
            dispatch(changeScreenIS("list-is"));
            Toastify({
              text: "Save Success",
              duration: 3000,
              gravity: "top",
              position: "right",
              style: { background: "#5EBA7D" }
            }).showToast();
          })
          .catch((err) => {
            setLoadingSave(false);
            if (isServerOrTimeout(err)) {
              goListScreen(); // langsung balik ke list
              return;
            }
            Toastify({
              text: err?.response?.data?.message || err?.data?.message || FALLBACK_MSG,
              duration: 3000,
              gravity: "top",
              position: "right",
              style: { background: "#CB605A" }
            }).showToast();
          });
      } else {
        setLoadingSave(false);
        Toastify({
          text: getValidationErrorMsg(
            isAmountValid,
            isTopPercentageValid,
            isInstallmentValid,
            isServiceMaterialFilled
          ),
          duration: 3000,
          gravity: "top",
          position: "right",
          style: { background: "#CB605A" }
        }).showToast();

      }
    }


    // === Blok SUBMIT (fixed) ===
    if (type === "submit") {
      // Safety net: paksa reset loading setelah 30 detik dalam kondisi apapun
      const loadingTimeout = setTimeout(() => {
        setLoadingSubmit(false);
      }, 30000);

      const resetLoading = () => {
        clearTimeout(loadingTimeout);
        setLoadingSubmit(false);
      };

      if (isAmountValid && isTopPercentageValid && isInstallmentValid && isServiceMaterialFilled) {
        if (data.TopType !== null) {
          if (allTrue) {
            let successMessage = "Invoice Success";
            dispatch(createInvoice(formData))
              .then((res) => {
                successMessage = res?.data?.message || res?.data?.Message || successMessage;
                const paymentReqNo = extractCreatedPaymentReqNo(res);

                resetLoading();

                if (!paymentReqNo) {
                  // Invoice berhasil dibuat tapi PRNo tidak terbaca — tetap redirect
                  console.warn("PaymentReqNo tidak ditemukan di response, redirect ke list.");
                  Toastify({
                    text: successMessage,
                    duration: 3000, gravity: "top", position: "right",
                    style: { background: "#5EBA7D" }
                  }).showToast();
                  dispatch(changeScreenIS("list-is"));
                  try { history.replace("/vdr/invoice-submission"); } catch { }
                  return;
                }

                Toastify({
                  text: successMessage,
                  duration: 3000, gravity: "top", position: "right",
                  style: { background: "#5EBA7D" }
                }).showToast();
                dispatch(changeScreenIS("list-is"));
                try { history.replace("/vdr/invoice-submission"); } catch { }

                dispatch(jurnalInvoice({ paymentReqNo })).catch((journalErr) => {
                  if (process.env.NODE_ENV !== "production") {
                    console.warn("JournalInvoice failed after invoice created", journalErr);
                  }
                });
              })
              .catch((err) => {
                resetLoading();

                if (typeof isServerOrTimeout === "function" && isServerOrTimeout(err)) {
                  if (typeof goListScreen === "function") {
                    goListScreen();
                  } else {
                    dispatch(changeScreenIS("list-is"));
                  }
                  return;
                }

                const msg =
                  err?.response?.data?.message ||
                  err?.data?.message ||
                  err?.message ||
                  FALLBACK_MSG;

                Toastify({
                  text: msg,
                  duration: 3000, gravity: "top", position: "right",
                  style: { background: "#CB605A" }
                }).showToast();

                if (msg === FALLBACK_MSG) {
                  setTimeout(() => {
                    dispatch(changeScreenIS("list-is"));
                    try { history.replace("/vdr/invoice-submission"); } catch { }
                  }, 250);
                }
              });
          } else {
            resetLoading();
            Toastify({
              text: "Please upload file mandatory",
              duration: 3000, gravity: "top", position: "right",
              style: { background: "#CB605A" }
            }).showToast();
          }
        } else {
          resetLoading();
          Toastify({
            text: "Please choose `type` in term of payment",
            duration: 3000, gravity: "top", position: "right",
            style: { background: "#CB605A" }
          }).showToast();
        }
      } else {
        resetLoading();
        Toastify({
          text: getValidationErrorMsg(
            isAmountValid,
            isTopPercentageValid,
            isInstallmentValid,
            isServiceMaterialFilled
          ),
          duration: 3000, gravity: "top", position: "right",
          style: { background: "#CB605A" }
        }).showToast();
      }
    }
  };

  const handleTaxConfig = (idTaxConf, amount) => {
    try {
      const taxConf = dropdownTaxConfig.find((q) => q.value === idTaxConf);
      // VAT
      let vatRate = taxConf.vat;
      return { vatRate }
    } catch {
      return { vat: 0, dpp: 0 }
    }
  }

  useEffect(() => {
    return () => {
      if (tableFilterDebounceRef.current) {
        clearTimeout(tableFilterDebounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (listCompanyCode.length >= 1 && listCompanyCode !== null) {
      let newDataTemp = [{ value: "", label: "---" }];
      let newDataCompany = listCompanyCode
      newDataCompany.forEach((data, i) => {
        newDataTemp.push({
          value: data.companyCode,
          label: data.companyCode,
        });
      });
      setCompanyCode(newDataTemp)
    }// eslint-disable-next-line
  }, [listCompanyCode])

  useEffect(() => {
    const poSource = _usePoClientMode ? allPoRowsCache : listPoRows;
    if (checkedListPO.length === poSource.length && checkedListPO.length > 0) {
      setCheckAllListPO(true);
    }
    else if (indeterminateListPO) {
      setCheckAllListPO(true);
    } else {
      setCheckAllListPO(false);

      if (checkedListPO.length === 0) {
        if (data.PaymentType === "Advanced Payment") {
          setCurrency(null)
          setData({
            ...data,
            selectedItemList: [],
            TopInstallment: 0,
            TopInstallmentDetail: [],
          });
        }

        setSelectedPO([])
        setData({
          ...data,
          selectedItemList: [],
          TotalAmountItemType: true,
          TotalAmountBeforeTax: 0,
          PONo: [],
          ItemList: [],
        });
        setCurrency(null)
        setSelectedRows([])
        setCheckedItemList([]);
        dispatch({
          type: "ITEM_LIST_PO",
          payload: [],
        });
      }
    }

    setSelectedPO(checkedListPO);
    const selectedIDs = new Set(checkedListPO);
    const selectedRowData = poSource.filter((row) =>
      selectedIDs.has(row.id)
    );
    if (selectedRowData.length >= 1) {
      let newPoNo = [];
      let itemListPo = [];
      let amountTemp = [];
      let curr = [];

      selectedRowData.forEach((d, i) => {
        itemListPo.push({
          PoNo: d.poNo
        })
        if (data.PaymentType === "Advanced Payment") {
          curr.push(d.currency)
        }

        newPoNo.push(d.poNo);
        amountTemp.push(getPoRemainingAmount(d))
      });
      setSelectedListPo(itemListPo)

      // checkitemlist sama dengan list po
      let newArray = [];
      let amountTempCredit = []
      const selectedRowsTemp = selectedRows
      const checkFilterItemList = selectedRowsTemp.filter((elem) => itemListPo.find(({ PoNo }) => elem.poNo === PoNo));
      setSelectedRows(checkFilterItemList)
      if (checkFilterItemList.length >= 1) {
        checkFilterItemList.forEach((dataPo) => {
          amountTempCredit.push(Number(dataPo.amountInvoice))
          newArray.push(dataPo["id"]);
        })
        setCheckedItemList(newArray);
      } else {
        setCheckedItemList([]);
      }

      let newAmmountBeforeTax = amountTemp.reduce((a, b) => a + b, 0).toFixed(2)

      let newAmmountBeforeTaxCredit = amountTempCredit.reduce((a, b) => a + b, 0).toFixed(2)
      if (data.PaymentType === "Credit Payment") {
        setData({
          ...data,
          PONo: newPoNo,
          TotalAmountBeforeTax: newAmmountBeforeTaxCredit
        })
      } else if (data.PaymentType === "Advanced Payment") {
        const uniqueCurr = [...new Set(curr)];
        setCurrency(uniqueCurr)
        setData({
          ...data,
          PONo: newPoNo,
          TotalAmountBeforeTax: newAmmountBeforeTax
        })
      }
    } else {
      setData({
        ...data,
        TotalAmountItemType: true,
        TotalAmountBeforeTax: 0,
        PONo: [],
        ItemList: [],
        selectedItemList: [],
      });
      setSelectedRows([])
      setCurrency(null);
      setSelectionModel([]);
      setSelectedRows([])
      setCheckedItemList([]);
      dispatch({
        type: "ITEM_LIST_PO",
        payload: [],
      });
    }
    //eslint-disable-next-line
  }, [checkAllListPO, checkedListPO, allPoRowsCache, listPoRows, _usePoClientMode])

  useEffect(() => {
    if (data.PaymentType.toLowerCase() === "credit payment") {
      if (checkedItemList.length === data.ItemList.length && checkedItemList.length > 0) {
        setCheckAllItemList(true);
      } else {
        setCheckAllItemList(false);

        if (checkedItemList.length === 0) {
          let dataNew = data.ItemList;
          const newDataCheckBox = dataNew.map((obj, i) => ({ ...obj, isCheckBox: false }));
          setData({
            ...data,
            ItemList: newDataCheckBox,
            TotalAmountBeforeTax: 0,
            selectedItemList: [],
          });
          setSelectedRows([])
          setCurrency(null);
        }
      }

      const selectedIDs = new Set(checkedItemList);
      const selectedRowData = data.ItemList.filter((row) =>
        selectedIDs.has(row.id)
      );

      if (selectedRowData.length >= 1 && selectedRowData !== undefined && selectedRowData !== null) {
        setSelectedRows(selectedRowData)
        let dataNew = data.ItemList;
        let amountTemp = [];
        let newData = [];
        let curr = [];

        selectedRowData.forEach((d, i) => {
          curr.push(d.currency)
          const selected = dataNew.findIndex((row) => row.conditionId === d.conditionId)
          dataNew[selected].isCheckBox = true
          amountTemp.push(Number(d.amountInvoice));
          newData.push({
            id: d.id,
            amountInvoice: Number(d.amountInvoice),
            item: d.item,
            billedQty: parseFloat(d.balanceQty),
            conditionId: d.conditionId,
            poNo: d.poNo,
          });
        });

        const unique = [...new Set(curr)];
        setCurrency(unique)

        const check = dataNew.filter((checkBox) => {
          return checkBox.isCheckBox === true
        })
        // let props = ['conditionId'];
        let unchecked = check.filter(function (o1) {
          // filter out (!) items in result2
          return !selectedRowData.some(function (o2) {
            return o1.id === o2.id;          // assumes unique id
          });
        })

        if (unchecked.length >= 1) {
          unchecked.forEach((d) => {
            const selected = dataNew.findIndex((row) => row.conditionId === d.conditionId)
            dataNew[selected].isCheckBox = false
          })
        }

        let newAmmountBeforeTax = amountTemp.reduce(
          (a, b) => a + b,
          0
        )


        let ammountTemp = []
        if (data.selectedItemType.length >= 1) {
          data.selectedItemType.forEach((d) => {
            ammountTemp.push(d.itemTypeAmount)
          })
        }

        let amountMaterial = ammountTemp.reduce((a, b) => a + b, 0).toFixed(2)
        const hasOtherWithAmount = data.selectedItemType.some(
          (item) => (item.itemTypeDesc === "Other" || item.description === "Other") && Number(item.itemTypeAmount || 0) !== 0
        );
        if (data.PaymentType === "Credit Payment") {
          let amtBeforeTax = Number(newAmmountBeforeTax).toFixed(2);
          const isMismatch = Number(amountMaterial).toFixed(2) !== amtBeforeTax;
          const shouldWarn = (hasOtherWithAmount && isExporter) ? false : isMismatch;
          setData({
            ...data,
            TotalAmountItemType: shouldWarn,
            ItemList: dataNew,
            TotalAmountBeforeTax: newAmmountBeforeTax,
            selectedItemList: newData,
          })
        } else if (data.PaymentType === "Advanced Payment") {
          const isMismatch = Number(amountMaterial).toFixed(2) !== Number(data.TopAmount).toFixed(2);
          const shouldWarn = (hasOtherWithAmount && isExporter) ? false : isMismatch;
          setData({
            ...data,
            TotalAmountItemType: shouldWarn,
          })
        }

      }
    }
    // eslint-disable-next-line
  }, [checkedItemList])

  useEffect(() => {
    if (checkedItemType.length === dataItemType.length && checkedItemType.length > 0) {
      setCheckAllItemType(true);
      setIndeterminateItemType(false);
    } else {
      setCheckAllItemType(false);

      if (checkedItemType.length === 0) {
        setData({
          ...data,
          selectedItemType: [],
          TotalAmountToBePaid: 0,
        });
      } else if (checkedItemType.length !== dataItemType.length && checkedItemType.length !== 0) {
        //set indeterminate false
        setIndeterminateItemType(false);
        setData({
          ...data,
          selectedItemType: [],
          TotalAmountToBePaid: 0,
        });
      }
    }

    const selectedIDs = new Set(checkedItemType);
    const selectedRowData = dataItemType.filter((row) =>
      selectedIDs.has(row.id)
    );

    if (selectedRowData.length >= 1) {
      let amountTemp = [];
      let dataTemp = [];

      selectedRowData.forEach((d, i) => {
        amountTemp.push(d.itemTypeWhtAmountToBePaid === null ? 0 : Number(d.itemTypeWhtAmountToBePaid));
        dataTemp.push({
          itemTypeNo: d.seq,
          itemTypeDesc: d.description,
          itemTypeAmount: d.itemTypeAmount === null ? 0 : Number(d.itemTypeAmount),
          itemTypeTaxConfId: d.itemTypeTaxConfId === undefined ? "" : d.itemTypeTaxConfId,
          itemTypeVat: d.itemTypeVat === null ? 0 : d.itemTypeVat,
          itemTypeVatRate: d.itemTypeVatRate === null ? 0 : d.itemTypeVatRate,
          itemTypeVatAmount: d.itemTypeVatAmount === null ? 0 : Number(d.itemTypeVatAmount),
          itemTypeDppRate: d.itemTypeDppRate === undefined ? 0 : d.itemTypeDppRate,
          itemTypeDppAmount: Number(d.itemTypeDppAmount),
          itemTypeWht: d.itemTypeWht,
          itemTypeWhtType: d.itemTypeWhtType,
          itemTypeWhtSubtype: d.itemTypeWhtSubtype,
          itemTypeWhtRate: d.itemTypeWhtRate === null ? 0 : Number(d.itemTypeWhtRate),
          itemTypeWhtAmount: d.itemTypeWhtAmount === null ? 0 : Number(d.itemTypeWhtAmount),
          itemTypeWhtAmountToBePaid: d.itemTypeWhtAmountToBePaid === null ? 0 : Number(d.itemTypeWhtAmountToBePaid),
        });
      });

      let newAmmountax = normalizeCurrencyAmount(
        amountTemp.reduce((a, b) => a + b, 0),
        currency?.[0]
      )

      // before tax === total amount service & material
      let ammountTemp = [];
      const filterMaterialService = selectedRowData.filter((d) => d.description === "Material" || d.description === "Services" || d.description === "Other")

      filterMaterialService.forEach((data, index) => {
        ammountTemp.push(data.itemTypeAmount === null ? 0 : data.itemTypeAmount)
      })

      let amountMaterial = normalizeCurrencyAmount(
        ammountTemp.reduce((a, b) => a + Number(b || 0), 0),
        currency?.[0]
      )

      const hasOtherWithAmount = dataItemType.some(
        (item) => (item.itemTypeDesc === "Other" || item.description === "Other") && Number(item.itemTypeAmount || 0) !== 0
      );
      if (data.PaymentType === "Credit Payment") {
        let amtBeforeTax = Number(data.TotalAmountBeforeTax || 0);
        const isMismatch = !isSameCurrencyAmount(amountMaterial, amtBeforeTax, currency?.[0]);
        const shouldWarn = (hasOtherWithAmount && isExporter) ? false : isMismatch;
        setData({
          ...data,
          TotalAmountServiceMaterial: amountMaterial,
          TotalAmountItemType: shouldWarn,
          TotalAmountToBePaid: newAmmountax,
          selectedItemType: dataTemp
        })
      } else if (data.PaymentType === "Advanced Payment") {
        const isMismatch = !isSameCurrencyAmount(amountMaterial, Number(data.TopAmount || 0), currency?.[0]);
        const shouldWarn = (hasOtherWithAmount && isExporter) ? false : isMismatch;
        setData({
          ...data,
          TotalAmountServiceMaterial: amountMaterial,
          TotalAmountItemType: shouldWarn,
          TotalAmountToBePaid: newAmmountax,
          selectedItemType: dataTemp,
        })
      }
    }

    // eslint-disable-next-line
  }, [checkedItemType])


  // dropdown wht & sub type wht
  useEffect(() => {
    if (data.TaxType.toLowerCase() === "taxable" && data.companyCode !== null && data.companyCode !== "") {
      setLoadingItemType(true);
      dispatch(getItemWhtType(`?CompanyCode=${data.companyCode}`)).then((res) => {
        let getData = res.data;
        let newDataWhtType = [{ label: "---", value: "---" }];
        if (getData.length >= 1) {
          const unique = [...new Set(getData.map(item => item.taxType))];
          unique.forEach((data, i) => {
            newDataWhtType.push({
              value: data,
              label: data,
            });

          });
          setWhtType(newDataWhtType);
        }
      })
        .then(() => {
          setLoadingItemType(false);
        })
        .catch(() => {
          setLoadingItemType(false);
        })

    }// eslint-disable-next-line
  }, [data.companyCode, data.TaxType, dataItemType])//,selectTemp,data.attachment,attachSupportDoc

  useEffect(() => {
    dispatch(getTaxConfiguration()).then((res) => {
      let getData = res.data;
      let newDataTaxType = [{ value: "", label: "---", vat: 0, dpp: 0, dppNumber: "", isPercentage: false }];
      if (getData.length >= 1) {
        const unique = [...new Set(getData)];
        unique.forEach((data, i) => {
          newDataTaxType.push({
            value: data.id,
            label: "VAT " + data.vatRate + "% (" + data.id + ")",
            vat: data.vatRate,
            dpp: data.dppRate,
            dppNumber: data.dppRateNumber,
            isPercentage: data.isPercentage
          });
        });
        setTaxConfig(newDataTaxType);
      }
    }).then(() => {
      setLoadingItemType(false);
    })
      .catch(() => {
        setLoadingItemType(false);
      })
  }, [])

  useEffect(() => {
    if (data.PaymentType === "Credit Payment") {
      const fetchData = async () => {
        const allPo = data.PONo;
        const dataTempItemList = data.ItemList;
        const existingPOs = dataTempItemList.map(item => item.poNo);

        // Determine new POs to fetch
        const newPOs = allPo.filter(po => !existingPOs.includes(po));
        // Determine POs to remove
        const removePOs = existingPOs.filter(po => !allPo.includes(po));

        // Remove old POs
        const updatedItemList = dataTempItemList.filter(item => !removePOs.includes(item.poNo));

        if (newPOs.length > 0) {
          setLoadingItemList(true);

          try {
            const res = await dispatch(getItemListPO({
              PONo: newPOs.join(","),
              VendorCode: listInfoVendor[0].vendorCode,
            }));
            const newData = res.data || [];

            newData.forEach((item) => {
              item.billedQty = item.balanceQty;
              item.amountInvoice = item.currency === "IDR"
                ? Math.ceil(Number(item.balanceQty * item.pricePerUnit))
                : Number(item.balanceQty * item.pricePerUnit).toFixed(2);
            });

            // Combine old and new data
            const combinedItemList = [...updatedItemList, ...newData];
            combinedItemList.sort((a, b) => Number(a.poNo) - Number(b.poNo));
            setData((prevData) => ({
              ...prevData,
              ItemList: combinedItemList,
              ItemListtemp: combinedItemList,
              selectedItemList: combinedItemList.filter(item => item.isCheckBox),
            }));
            setSelectedRows(combinedItemList.filter(item => item.isCheckBox));
          } catch (error) {
            console.error("Error processing POs:", error);
          } finally {
            setLoadingItemList(false);
          }
        } else {
          setData((prevData) => ({
            ...prevData,
            ItemList: updatedItemList,
            ItemListtemp: updatedItemList,
            selectedItemList: updatedItemList.filter(item => item.isCheckBox),
          }));
          setSelectedRows(updatedItemList.filter(item => item.isCheckBox));
        }
      };

      fetchData();
    }
    // eslint-disable-next-line
  }, [selectPO, data.PaymentType, data.TopAmount, data.PONo]);

  useEffect(() => {
    setSelectionModel(
      data.ItemList.filter((r, i) => r.isCheckBox === true).map((r) => r.id)
    );
  }, [data.ItemList, selectedRows, selectPO]);

  useEffect(() => {
    let newDataBank = [{ value: "", label: "Choose Here" }];
    let bankData = listBankAccount
    bankData.forEach((data, i) => {
      newDataBank.push({
        value: data.bankCode,
        label: data.bankCode,
      });
    });

    window.scrollTo(0, 0)
    setBankCode(newDataBank)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    let newDataBankNo = [{ value: "", label: "Choose Here" }];

    if (data.BankName !== '' && data.BankName !== null) {
      let bankData = listBankAccount.filter((d) => {
        return d.bankCode === data.BankName
      });
      bankData.forEach((data, i) => {
        newDataBankNo.push({
          value: data.bankAccount,
          label: data.bankAccount,
        });
      });
    }

    setBankNo(newDataBankNo)
    // eslint-disable-next-line
  }, [data.BankName])

  const handleDetail = (poNo, id) => {
    setLoadingChangePage(true);
    dispatch(getDetailPO(`?VendorCode=${listInfoVendor[0].vendorCode}&PurchaseNo=${poNo}`))
      .then(() => {
        setLoadingChangePage(false);
        dispatch(changeScreenPO("detail-po"));
        history.push(`/vdr/purchase-order?Id=${id}`);
      })
      .catch(() => {
        setLoadingChangePage(false);
      });
  };



  return (
    <Page title="Invoice Submission">
      <Navbar />
      <div className="container-vendor">
        <div className="header-vendor-invoice">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h6>Create Invoice</h6>
              <p>{`${moment(today).format("dddd, DD MMMM YYYY")}`}</p>
            </div>
            <div>
              <span>Total Amount to be paid</span>
              {currency !== null && currency[0] === "IDR" ? <h2>{`${currency[0]} ${ConvertFormat(data.TotalAmountToBePaid)}`}</h2> : currency !== null ?
                <h2>{`${currency[0]} ${Number(data.TotalAmountToBePaid).toFixed(2)}`}</h2> : <h2>{Number(data.TotalAmountToBePaid).toFixed(2)}</h2>
              }
            </div>
          </div>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              marginLeft: "20px",
              justifyContent: "flex-end",
            }}
          >
            <Button
              btn="btn-vendor-outlined"
              title="Back"
              onClick={handleBack}
            />
            {loadingSave === true ?

              <div className="btn-for-vendor-outlined">
                <Button
                  btn="btn-download-loader"
                />
              </div>
              :
              <Button
                btn="btn-vendor-outlined"
                onClick={() => handleSave("save")}
                title="Save"
                disabled={loadingSubmit === true ? true : false}
              />
            }
            {loadingSubmit === true ?
              <div className="btn-for-vendor-loading-submit">
                <Button
                  btn="btn-download-loader"
                />
              </div> :
              <Button btn="btn-vendor-fill" title="Submit" onClick={() => handleSave("submit")} disabled={loadingSave === true ? true : false} />

            }
          </div>
        </div>
        <div className="content-list-po" style={{ marginTop: "220px" }}>
          <div className="square">
            <h3>Payment Request</h3>
            <Grid container spacing={2}>
              <Grid className="detail-info" item xs={3} md={3}>
                <label htmlFor="PaymentRequestNumber">
                  Payment Request Number
                </label>
                <input
                  disabled={true}
                  id="PaymentRequestNumber"
                  name="PaymentRequestNumber"
                  type="text"
                  value={"Will be generated automatically"}
                />
                <label htmlFor="PaymentType">Payment Type</label>
                <select
                  className="select-create-invoice"
                  id="PaymentType"
                  name="PaymentType"
                  onChange={handleChangeHeader}
                  defaultValue={'DEFAULT'}
                >
                  <option value="DEFAULT" disabled>
                    ---
                  </option>
                  <option value="Credit Payment">Credit Payment</option>
                  <option value="Advanced Payment">Advanced Payment</option>
                </select>

              </Grid>
              <Grid className="detail-info" item xs={3} md={3}>
                <label htmlFor="invoiceDate">Invoice Date</label>
                <input
                  disabled={true}
                  id="invoiceDate"
                  name="invoiceDate"
                  type="text"
                  defaultValue={moment(today).format("DD MMM YYYY")}
                />

                <label htmlFor="TaxType">Tax Type</label>
                <select
                  className="select-create-invoice"
                  id="TaxType"
                  name="TaxType"
                  onChange={handleChangeHeader}
                  defaultValue={'DEFAULT'}
                >
                  <option value="DEFAULT" disabled>
                    ---
                  </option>
                  <option value="Taxable">Taxable</option>
                  <option value="nonTaxable">Non Taxable</option>
                </select>
              </Grid>
              <Grid className="detail-info" item xs={3} md={3}>
                <label htmlFor="VendorInvoiceNumber">
                  Vendor Invoice Number
                </label>
                <input
                  // disabled={loading === false ? true:false}
                  style={{ background: "#FFFFFF" }}
                  id="VendorInvoiceNumber"
                  name="VendorInvoiceNumber"
                  type="text"
                  onChange={handleFormChange}
                  value={data.VendorInvoiceNumber}
                />
                <label htmlFor="companyCode">Company Code</label>
                <select
                  className="select-create-invoice"
                  id="companyCode"
                  name="companyCode"
                  onChange={handleChangeHeader}
                  value={data.companyCode === null ? "" : data.companyCode}
                >
                  {dropdownCompanyCode.map((status, key) => (
                    <option key={"companyCode-" + key} value={status.value} hidden={status.value === "" ? true : false} >
                      {status.label}
                    </option>
                  ))}
                </select>
              </Grid>
              <Grid className="detail-info" item xs={3} md={3}>
                <label htmlFor="poType">PO Type</label>
                <select
                  className="select-create-invoice"
                  id="poType"
                  name="poType"
                  onChange={handleChangeHeader}
                  defaultValue={'DEFAULT'}
                >
                  <option value="DEFAULT" disabled>
                    ---
                  </option>
                  <option value="1">Trade</option>
                  <option value="0">Non Trade</option>
                </select>

                <label htmlFor="paymentTerm">Payment Term</label>
                <select
                  className="select-create-invoice"
                  id="paymentTerm"
                  name="paymentTerm"
                  onChange={handleChangeHeader}
                  defaultValue={'DEFAULT'}
                >
                  <option value="DEFAULT" disabled>
                    ---
                  </option>
                  <option value="CASH">CASH - Payable immediately Due net</option>
                  <option value="0004">0004 - Payable immediately Due net</option>
                  <option value="0001">0001 - Payable immediately Due net</option>
                  <option value="I120">I120 - Within 120 days Due net</option>
                  <option value="I160">I160 - Payment in 160 days</option>
                  <option value="I180">I180 - Payment in 180 days</option>
                  <option value="I365">I365 - Payment in 365 days</option>
                  <option value="IN07">IN07 - Payment in 7 days</option>
                  <option value="IN14">IN14 - Payment in 14 days</option>
                  <option value="IN30">IN30 - Payment in 30 days</option>
                  <option value="IN45">IN45 - Payment in 45 days</option>
                  <option value="IN60">IN60 - Payment in 60 days</option>
                  <option value="IN90">IN90 - Payment in 90 days</option>
                  <option value="IN75">IN75 - Payment in 75 days</option>
                  <option value="COD">COD - Cash On Delivery</option>
                  <option value="CBD">CBD - Cash Before Delivery</option>
                  <option value="">---</option>
                </select>
              </Grid>
            </Grid>
          </div>
        </div>


        {/* list PO */}
        <div className="content-list-po">
          <div className="square-table">
            <h3 style={{ marginLeft: "30px" }}>List Purchase Order</h3>
            <Box
              sx={{
                height: 700,
                width: 1,
                "& .super-app-theme--header": {
                  backgroundColor: "#001D61",
                  color: "#FFFFFF",
                  fontFamily: "Quicksand",
                  fontSize: "12px",
                  fontWeight: "bold",
                },
              }}
            >
              {loadingListPO ? (
                <Skeleton height={700} variant="rectangular" />
              ) : (
                (() => {
                  return (
                    <CustomDataGrid
                      columns={theColumns}
                      rows={data.companyCode ? (_usePoClientMode ? allPoRowsCache : listPoRows) : []}
                      disableSelectionOnClick
                      paginationMode={_usePoClientMode ? "client" : "server"}
                      filterMode={_usePoClientMode ? "client" : "server"}
                      filterModel={_usePoClientMode ? poTableFilterModel : undefined}
                      onFilterModelChange={handleTableFilterChange}
                      rowCount={data.companyCode && !_usePoClientMode ? (poPagination?.totalCount || listPoRows.length) : undefined}
                      page={pagePO}
                      pageSize={pageSizePO}
                      onPageChange={(newPage) => {
                        setPagePO(newPage);
                        if (!_usePoClientMode) {
                          loadListPO(activePOQuery, newPage, pageSizePO);
                        }
                      }}
                      onPageSizeChange={(newPageSize) => {
                        setPageSizePO(newPageSize);
                        setPagePO(0);
                        if (!_usePoClientMode) {
                          loadListPO(activePOQuery, 0, newPageSize);
                        }
                      }}
                      rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                      pagination
                      onRowDoubleClick={(params) => {
                        const selectedRow = params.row;
                        handleDetail(selectedRow.purchaseNo, selectedRow.id);
                      }}
                    />
                  );
                })()
              )}
            </Box>
          </div>
        </div>

        <div>
          {data.PaymentType === "Credit Payment" && data.PONo.length >= 1 && (
            <div className="content-list-po">
              <div className="square-table">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <h3 style={{ marginLeft: "30px" }}>Item List</h3>

                  <div
                    style={{
                      display: "flex",
                      marginRight: "20px"
                    }}
                  >
                    <Button btn="btn-vendor-export" title="EXPORT" onClick={() => exportToExcel()}>Export</Button>
                    <Button btn="btn-vendor-upload" title="UPLOAD" onClick={() => setUploadItemList(true)} />
                  </div>
                </div>
                <Box
                  sx={{
                    height: 700,
                    width: 1,
                    "& .super-app-theme--header": {
                      backgroundColor: "#001D61",
                      color: "#FFFFFF",
                      fontFamily: "Quicksand",
                      fontSize: "12px",
                      fontWeight: "bold",
                    },
                  }}
                >
                  {
                    loadingItemList ? (
                      <Skeleton
                        height={700}
                        variant="rectangular"
                      />
                    ) : (
                      <CustomDataGrid
                        // checkboxSelection
                        columns={columnItemList}
                        disableSelectionOnClick
                        filterMode="server"
                        filterModel={itemListFilterModel}
                        onFilterModelChange={handleItemListFilterChange}
                        pageSize={pageSizeItemList}

                        onPageSizeChange={(newPageSize) => {
                          setPageSizeItemList(newPageSize)
                        }}
                        // components={{ Toolbar: customToolbar }}
                        pagination
                        PreviewMouseDoubleClick
                        rows={filteredItemListRows}
                        rowsPerPageOptions={[5, 10, 25, 100]}
                        selectionModel={selectionModel}
                      />
                    )
                  }
                </Box>
              </div>
            </div>
          )}
          <div className="content-list-po">
            <div className="square">
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <p>Subtotal Amount before Tax</p>
                {currency !== null && currency[0] === "IDR" ? <h5>{`${currency[0]} ${ConvertFormat(data.TotalAmountBeforeTax)}`}</h5> : currency !== null ?
                  <h5>{`${currency[0]} ${Number(data.TotalAmountBeforeTax).toFixed(2)}`}</h5>
                  :
                  <h5>{Number(data.TotalAmountBeforeTax).toFixed(2)}</h5>
                }
              </div>
            </div>
          </div>

          {/* term of payment AdvancedPayment*/}
          {data.PaymentType === "Advanced Payment" && (
            <div className="content-list-po">
              <div className="square">
                <h3>Term of Payment</h3>
                <Grid container spacing={2}>
                  <Grid className="detail-info" item xs={3} md={3}>
                    <label htmlFor="TopType">Type</label>
                    <select
                      className="select-create-invoice"
                      id="TopType"
                      name="TopType"
                      onChange={handleFormChange}
                      style={{ marginBottom: "30px" }}
                      defaultValue={'DEFAULT'}
                    >
                      <option value="DEFAULT" disabled selected>
                        ---
                      </option>
                      <option value="DownPayment">Down Payment</option>
                      <option value="COD">COD (Cash on Delivery)</option>
                      <option value="CBD">CBD (Cash before Delivery)</option>
                    </select>
                    <label htmlFor="TopPercentage">Percentage</label>
                    <input
                      id="TopPercentage"
                      name="TopPercentage"
                      type="number"
                      onChange={handleFormChange}
                      value={data.TopPercentage}
                      style={{ backgroundColor: "#FFFFFF" }}
                    />
                  </Grid>
                  <Grid className="detail-info" item xs={3} md={3}>
                    <label htmlFor="TopDueDate">Due Date</label>
                    <input
                      id="TopDueDate"
                      name="TopDueDate"
                      type="date"
                      onChange={handleFormChange}
                      value={data.TopDueDate}
                      defaultValue={data.TopDueDate}
                      style={{ backgroundColor: "#FFFFFF", marginBottom: "30px" }}
                      min={new Date().toISOString().split('T')[0]} // menonaktifkan tanggal sebelum hari ini
                      //disabled // menonaktifkan input tanggal
                      onKeyDown={(e) => e.preventDefault()} // Mencegah input melalui keyboard

                    />
                    <label htmlFor="TopAmount">Amount</label>
                    <input disabled={true} Value={data.TopAmount} id="TopAmount" name="TopAmount" style={{
                      border:
                        data.TopPercentageCondition === true ? "1px solid #CB605A" : "",
                    }} type="text" />
                  </Grid>
                </Grid>
              </div>
            </div>
          )}

          {/* item type */}
          <div className="content-list-po">
            <div className="square-table">
              <h3 style={{ marginLeft: "30px" }}>Item Type</h3>
              <Box
                sx={{
                  height: 316, // 5 baris + header
                  width: 1,
                  "& .super-app-theme--header": {
                    backgroundColor: "#001D61",
                    color: "#FFFFFF",
                    fontFamily: "Quicksand",
                    fontSize: "12px",
                    fontWeight: "bold",
                  },
                }}
              >
                {loadingItemType ? (
                  <Skeleton height={316} variant="rectangular" />
                ) : (
                  <DataGrid
                    columns={columnItemType}
                    rows={dataItemType}
                    disableRowSelectionOnClick
                    isRowSelectable={(params) =>
                      params.row.itemTypeAmount !== null &&
                      Number(params.row.itemTypeAmount) !== 0
                    }
                    hideFooterPagination
                    hideFooter
                    sx={{
                      height: 316,
                      '& .MuiDataGrid-virtualScroller': {
                        overflowY: 'auto',
                      },
                      '& .MuiDataGrid-cell': {
                        padding: '8px',
                      },
                      fontSize: '13px',
                    }}
                  />
                )}
              </Box>

              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  margin: "30px",
                  gap: "12px",
                }}
              >
                <h2>Total Amount to be paid</h2>
                <h5>
                  {currency?.length > 0 ? (
                    currency[0] === "IDR" ? (
                      `${currency[0]} ${ConvertFormat(data.TotalAmountToBePaid || 0)}`
                    ) : (
                      `${currency[0]} ${(data.TotalAmountToBePaid || 0).toFixed(2)}`
                    )
                  ) : (
                    (data.TotalAmountToBePaid || 0).toFixed(2)
                  )}
                </h5>
              </div>
            </div>
          </div>


          {/* bank info */}
          <div className="content-list-po">
            <div className="square">
              <h3>Bank Account Information</h3>
              <Grid container spacing={2}>
                <Grid className="detail-info" item xs={3} md={3}>
                  <label htmlFor="BankName">Bank</label>
                  <select
                    className="select-create-invoice"
                    id="BankName"
                    name="BankName"
                    onChange={handleFormChange}
                    style={{ marginBottom: "30px" }}
                    value={data.BankName === null ? "" : data.BankName}
                  >
                    {dropdownBank.map((status, key) => (
                      <option key={"dropdownBank-" + key} value={status.value} hidden={status.value === "" ? true : false}>
                        {status.label}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="BankAccountNo">Account No</label>
                  <select
                    className="select-create-invoice"
                    id="BankAccountNo"
                    name="BankAccountNo"
                    onChange={handleFormChange}
                    style={{ marginBottom: "30px" }}
                    value={data.BankAccountNo === null ? "" : data.BankAccountNo}
                  >
                    {dropdownBankNo.map((status, key) => (
                      <option key={"dropdownBankNo-" + key} value={status.value} hidden={status.value === "" ? true : false}>
                        {status.label}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="BankAccountName">Account Name</label>
                  <input
                    disabled={true}
                    id="BankAccountName"
                    name="BankAccountName"
                    type="text"
                    value={data.BankAccountName || ""}
                  />
                </Grid>
              </Grid>
            </div>
          </div>

          {/* Installment*/}
          {data.PaymentType === "Advanced Payment" && (
            <div className="content-list-po">
              <div className="square-table">
                <h3 style={{ marginLeft: "30px" }}>Installment</h3>
                <Grid container spacing={2}>
                  <Grid className="detail-info" item xs={3} md={3}>
                    <label htmlFor="TopType" style={{ marginLeft: "15px" }}>
                    </label>
                    <div
                      className="select-create-invoice"
                      id="TopType"
                      name="TopType"
                      onChange={handleFormChange}
                      style={{ marginBottom: "30px", marginLeft: "30px" }}
                    >
                      <option value="Installment">
                        Installment
                      </option>
                    </div>

                    {data.PaymentType === "Advanced Payment" ? (
                      <>
                        <label
                          htmlFor="TopInstallment"
                          style={{ marginLeft: "30px" }}
                        >
                        </label>
                        <div
                          style={{
                            display: "flex",
                            position: "relative",
                            marginLeft: "30px",
                            width: "100%",
                          }}
                        >
                          <Button
                            btn="btn-decrease"
                            onClick={() =>
                              handleDecreaseBtn(parseInt(data.TopInstallment))
                            }
                          />
                          <input
                            id="TopInstallment"
                            name="TopInstallment"
                            type="number"
                            min="0"
                            step="1"
                            onPaste={preventPasteNegative}
                            onKeyPress={preventMinus}
                            onChange={handleFormChange}
                            value={data.TopInstallment}
                            style={{
                              backgroundColor: "#FFFFFF",
                              textAlign: "center",
                            }}
                          />
                          <Button
                            btn="btn-increase"
                            onClick={() =>
                              handleIncreaseBtn(parseInt(data.TopInstallment))
                            }
                          />
                        </div>
                      </>
                    ) : null}
                  </Grid>
                </Grid>
                {data.TopInstallment > 0 && (
                  <Box
                    sx={{
                      height: 300,
                      width: "100%",
                      "& .super-app-theme--header": {
                        backgroundColor: "#001D61",
                        color: "#FFFFFF",
                        fontFamily: "Quicksand",
                        fontSize: "12px",
                        fontWeight: "bold",
                      },
                    }}
                  >
                    <CustomDataGrid
                      pageSize={10}
                      PreviewMouseDoubleClick
                      columns={columnInstallment}
                      disableSelectionOnClick
                      rows={TopInstallmentDetail}
                    />
                  </Box>
                )}
              </div>
            </div>
          )}

          {/* term off payment */}
          {data.PaymentType === "Credit Payment" && (
            <div className="content-list-po">
              <div className="square-table">
                <h3 style={{ marginLeft: "30px" }}>Term of Payment</h3>
                <Grid container spacing={2}>
                  <Grid className="detail-info" item xs={3} md={3}>
                    <label htmlFor="TopType" style={{ marginLeft: "30px" }}>
                      Type
                    </label>
                    <select
                      className="select-create-invoice"
                      id="TopType"
                      name="TopType"
                      onChange={handleFormChange}
                      style={{ marginBottom: "30px", marginLeft: "30px" }}
                    >
                      <option disabled selected>
                        ---
                      </option>
                      <option value="Installment">Installment</option>
                      <option value="Credit">Credit</option>
                    </select>

                    {data.PaymentType === "Credit Payment" &&
                      data.TopType === "Installment" ? (
                      <>
                        <label
                          htmlFor="TopInstallment"
                          style={{ marginLeft: "30px" }}
                        >
                          Installment
                        </label>
                        <div
                          style={{
                            display: "flex",
                            position: "relative",
                            marginLeft: "30px",
                            width: "100%",
                          }}
                        >
                          <Button
                            btn="btn-decrease"
                            onClick={() =>
                              handleDecreaseBtn(parseInt(data.TopInstallment))
                            }
                          />
                          <input
                            id="TopInstallment"
                            name="TopInstallment"
                            type="number"
                            min="0"
                            step="1"
                            onPaste={preventPasteNegative}
                            onKeyPress={preventMinus}
                            onChange={handleFormChange}
                            value={data.TopInstallment}
                            style={{
                              backgroundColor: "#FFFFFF",
                              textAlign: "center",
                            }}
                          />
                          <Button
                            btn="btn-increase"
                            onClick={() =>
                              handleIncreaseBtn(parseInt(data.TopInstallment))
                            }
                          />
                        </div>
                      </>
                    ) : data.PaymentType === "Credit Payment" &&
                      data.TopType === "Credit" ? (
                      <>
                        <label
                          htmlFor="TopDueDate"
                          style={{ marginLeft: "30px" }}
                        >
                          Due Date
                        </label>
                        <input
                          id="TopDueDate"
                          name="TopDueDate"
                          defaultValue={data.TopDueDate}
                          type="date"
                          onChange={handleFormChange}
                          style={{ backgroundColor: "#FFFFFF", marginLeft: "30px" }}
                          min={new Date().toISOString().split('T')[0]} // menonaktifkan tanggal sebelum hari ini
                          //disabled // menonaktifkan input tanggal
                          onKeyDown={(e) => e.preventDefault()} // Mencegah input melalui keyboard
                        />
                      </>
                    ) : null}
                  </Grid>
                </Grid>
                {data.TopInstallment > 0 && (
                  <Box
                    sx={{
                      height: 300,
                      width: "100%",
                      "& .super-app-theme--header": {
                        backgroundColor: "#001D61",
                        color: "#FFFFFF",
                        fontFamily: "Quicksand",
                        fontSize: "12px",
                        fontWeight: "bold",
                      },
                    }}
                  >
                    <CustomDataGrid
                      pageSize={10}
                      PreviewMouseDoubleClick
                      columns={columnInstallment}
                      disableSelectionOnClick
                      rows={TopInstallmentDetail}
                    />
                  </Box>
                )}
              </div>
            </div>
          )}

          {/* Supporting Document */}
          <div className="content-list-po">
            <div className="square-table">
              <h3>Supporting Document</h3>
              <Box
                sx={{
                  height: 900,
                  width: "100%",
                  "& .super-app-theme--header": {
                    backgroundColor: "#001D61",
                    color: "#FFFFFF",
                    fontFamily: "Quicksand",
                    fontSize: "12px",
                    fontWeight: "bold",
                  },
                }}
              >
                <CustomDataGrid
                  // pageSize={15}
                  columns={columnSupportDoc}
                  disableSelectionOnClick
                  rows={attachSupportDoc}
                  PreviewMouseDoubleClick
                />
              </Box>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        // fullScreen={fullScreen}
        open={uploadItemList}
        onClose={() => setUploadItemList(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Upload"}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText className="dialog-poTrade">
            <Grid container spacing={2}>
              <Grid className="label-dialog-poTrade" item xs={4} md={4}>
                <label htmlFor="uploadFile">Upload File</label>
              </Grid>
              <Grid className="label-dialog-poTrade" item xs={8} md={8}>
                <input className="file-upload" type="file" id="uploadFile" onChange={(e) => setFileUploadItemList(e.target.files[0])} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setUploadItemList(false)}
            btn="btn-vendor-outlined"
            title="Cancel"
          />
          {loadingUpload === true ?
            <div className="btn-for-vendor-loading-submit">
              <Button
                btn="btn-download-loader"
              />
            </div> :
            <Button onClick={handleUploadItemList} btn="btn-vendor-fill" title="Upload" />

          }
        </DialogActions>
      </Dialog>

      {/* dialog error message */}
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        // fullScreen={fullScreen}
        open={errorDialog}
        onClose={() => setErrorDialog(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Error Detail</DialogTitle>
        <DialogContent dividers>
          <DialogContentText className="dialog-poTrade">
            <Grid item xs={12}>
              <Box
                sx={{
                  height:
                    pageErr === 5
                      ? 400
                      : pageErr === 10
                        ? 700
                        : pageErr === 25
                          ? 1800
                          : 2000,
                  width: 1,
                  "& .super-app-theme--header": {
                    backgroundColor: "#CB605A",
                    color: "#FFFFFF",
                    fontFamily: "Quicksand",
                    fontSize: "12px",
                    fontWeight: "bold",
                  },
                }}
              >
                <CustomDataGrid
                  columns={theColumnsError}
                  disableSelectionOnClick
                  pageSize={pageErr}
                  PreviewMouseDoubleClick
                  onPageSizeChange={(newPageSize) => setPageErr(newPageSize)}
                  rows={listErrorMsg}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                />
              </Box>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setErrorDialog(false)}
            btn="btn-vendor-outlined"
            color="red"
            title="Cancel"
          />
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default InvoiceSubmission;
